<template>
  <div v-if="initPage">
    <div v-loading="true" class="loading"></div>
  </div>
  <div v-else>
    <el-row type="flex" justify="space-between">
      <div class="info-filter">
        <span v-if="relationshipFilter.period.enabled">
          {{ $t("common.filter.info.periodWith") }}
          {{ relationshipFilter.period.dateBegin }}
          {{ $t("common.filter.info.periodTo") }}
          {{ relationshipFilter.period.dateEnd }}
        </span>
        <span v-if="relationshipFilter.organization.enabled"
          >{{ $t("common.filter.info.organization") }} -
          {{ organizationName }}</span
        >
        <span v-if="relationshipFilter.payment.enabled"
          >{{ $t("common.filter.info.payment") }} - {{ paymentName }}</span
        >
        <span v-if="relationshipFilter.sum.enabled">
          {{ $t("common.filter.info.sumMin") }}
          {{ relationshipFilter.sum.sumBegin }}
          {{ params.goptions.monetary_unit }},
          {{ $t("common.filter.info.sumMax") }}
          {{ relationshipFilter.sum.sumEnd }}
          {{ params.goptions.monetary_unit }}
        </span>
        <span v-if="relationshipCompliance.datesDifference.enabled">
          {{ $t("common.compliance.info.datesDifference") }} -
          {{ relationshipCompliance.datesDifference.days }}
        </span>

        <span v-if="relationshipCompliance.organizationsMatch.enabled">{{
          $t("common.compliance.info.organizationsMatch")
        }}</span>
        <span v-if="relationshipCompliance.paymentMethodsMatch.enabled">{{
          $t("common.compliance.info.paymentMethodsMatch")
        }}</span>
        <span v-if="relationshipCompliance.amountDifference.enabled">
          {{ $t("common.compliance.info.amountDifference") }}
          {{ relationshipCompliance.amountDifference.summa }}
          {{ params.goptions.monetary_unit }}
        </span>
      </div>
      <div class="buttons-header">
        <el-button
          :type="filterType"
          size="small"
          @click="filterModal = true"
          v-shortkey="{ F7: ['f7'] }"
          @shortkey.native="onShortKeyRouter"
          ><span class="key-name">F7</span
          >{{ $t("common.buttons.filter") }}</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="complianceModal = true"
          v-shortkey="{ F9: ['f9'] }"
          @shortkey.native="onShortKeyRouter"
          ><span class="key-name">F9</span
          >{{ $t("common.buttons.compliance") }}</el-button
        >
      </div>
    </el-row>

    <el-row type="flex" justify="space-between">
      <el-col :span="24" class="grid-container">
        <ag-grid-vue
          style="width: 100%; height: 100%; text-align: center; font-family: 'Open Sans', sans-serif;"
          class="ag-theme-balham"
          rowSelection="single"
          :columnDefs="paymentsRelationColumnDefs"
          :rowData="paymentsRelationship"
          :defaultColDef="defaultColDef"
          :gridOptions="paymentsRelationGridOptions"
          @grid-ready="onPaymentsRelationGridReady"
          @first-data-rendered="onFirstPaymentsRelationDataRendered"
          @gridSizeChanged="onGridSizeChanged"
          @modelUpdated="onPaymentsRelationModelUpdated"
          @rowSelected="onPaymentsRelationRowSelected"
          @cellContextMenu="onPaymentsRelationRowRightClicked"
        ></ag-grid-vue>
      </el-col>
    </el-row>

    <el-row type="flex" justify="space-between">
      <el-col :span="24" class="grid-container">
        <ag-grid-vue
          style="width: 100%; height: 100%; text-align: center; font-family: 'Open Sans', sans-serif;"
          class="ag-theme-balham"
          rowSelection="single"
          :columnDefs="packsSource"
          :rowData="packsRelationship"
          :defaultColDef="defaultColDef"
          :gridOptions="packsRelationGridOptions"
          @grid-ready="onPacksRelationshipGridReady"
          @first-data-rendered="onFirstPacksRelationDataRendered"
          @gridSizeChanged="onGridSizeChanged"
          @modelUpdated="onPacksRelationModelUpdated"
          @rowSelected="onPacksRelationRowSelected"
          @cellContextMenu="onPacksRelationshipRowRightClicked"
        ></ag-grid-vue>
      </el-col>
    </el-row>

    <el-row type="flex" justify="space-between" style="margin-top: 10px">
      <el-col :span="24">
        <el-button
          type="primary"
          size="small"
          :disabled="linkBtnDisabled"
          @click="linkBtn"
          v-shortkey="{ Enter: ['enter'], Insert: ['insert'], Plus: ['+'] }"
          @shortkey.native="onShortKeyRouter"
          ><span class="key-name">Ins</span
          >{{ $t("common.buttons.link") }}</el-button
        >
        <el-button
          v-if="linkAndPostingBtnVisibled"
          type="primary"
          size="small"
          @click="linkAndPostingBtn"
          v-shortkey="{ F6: ['f6'] }"
          @shortkey.native="onShortKeyRouter"
          ><span class="key-name">F6</span
          >{{ $t("common.buttons.linkAndPosting") }}</el-button
        >
        <el-button
          v-if="packForPaymentBtnVisibled"
          type="primary"
          size="small"
          :disabled="packForPaymentBtnDisabled"
          @click="packForPaymentBtn"
          v-shortkey="{ F8: ['f8'] }"
          @shortkey.native="onShortKeyRouter"
          ><span class="key-name">F8</span
          >{{ $t("common.buttons.packForPayment") }}</el-button
        >
        <el-button
          v-if="false"
          type="primary"
          size="small"
          @click="errorPaymentsBtn"
          >{{ $t("common.buttons.errorPayments") }}</el-button
        >
      </el-col>
    </el-row>

    <el-dialog
      :title="$t('common.filter.modal.title')"
      :visible.sync="filterModal"
      :close-on-click-modal="false"
      @open="filterModalShow"
      @close="filterModalHide"
      :width="dialogWidth"
      class="resize"
      center
      v-draggable
    >
      <el-form :model="filterForm" :rules="filterRules" ref="filterForm">
        <el-row type="flex" justify="space-between">
          <el-col :span="1">
            <el-form-item>
              <el-checkbox
                v-model="filterForm.dateEnabled"
                disabled
              ></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item>
              <div>{{ $t("common.filter.form.dateRange.title") }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-form-item>
              <div style="text-align: center">с</div>
            </el-form-item>
          </el-col>
          <el-col :span="17">
            <el-form-item prop="dateRange">
              <el-date-picker
                v-model="filterForm.dateRange"
                type="daterange"
                :start-placeholder="$t('common.filter.form.dateRange.start')"
                :end-placeholder="$t('common.filter.form.dateRange.end')"
                :range-separator="$t('common.filter.form.dateRange.separator')"
                format="dd.MM.yyyy"
                value-format="dd.MM.yyyy"
                unlink-panels
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="1">
            <el-form-item>
              <el-checkbox
                v-model="filterForm.organizationEnabled"
              ></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item>
              <div>{{ $t("common.filter.form.organization.title") }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-form-item>
              <div>&nbsp;</div>
            </el-form-item>
          </el-col>
          <el-col :span="17">
            <el-form-item prop="organizationCode">
              <el-select
                v-model="filterForm.organizationCode"
                :placeholder="$t('common.components.select.placeholder')"
                clearable
                filterable
                :disabled="!filterForm.organizationEnabled"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in params.gfirme.data"
                  :key="item.codefirme"
                  :label="item.namefirme"
                  :value="item.codefirme"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="1">
            <el-form-item>
              <el-checkbox v-model="filterForm.paymentEnabled"></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item>
              <div>{{ $t("common.filter.form.payment.title") }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-form-item>
              <div>&nbsp;</div>
            </el-form-item>
          </el-col>
          <el-col :span="17">
            <el-form-item prop="paymentCode">
              <el-select
                v-model="filterForm.paymentCode"
                :placeholder="$t('common.components.select.placeholder')"
                clearable
                filterable
                :disabled="!filterForm.paymentEnabled"
                style="width: 100%;"
              >
                <el-option
                  v-for="item in params.gkindpay.data"
                  :key="item.kindpay"
                  :label="item.kindname"
                  :value="item.kindpay"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="1">
            <el-form-item>
              <el-checkbox v-model="filterForm.sumEnabled"></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item>
              <div>{{ $t("common.filter.form.sumRange.title") }}</div>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-form-item>
              <div style="text-align: center">
                {{ $t("common.filter.form.sumRange.from") }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="sumRange">
              <currency-input
                placeholder="0.00"
                v-model.lazy="filterForm.sumBegin"
                :disabled="!filterForm.sumEnabled"
                class="el-input--small el-input__inner"
                :class="{ moneydisable: !filterForm.sumEnabled }"
                style="width: 100%; height: 36px; line-height: 36px;"
              />
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-form-item>
              <div style="text-align: center">
                {{ $t("common.filter.form.sumRange.to") }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item>
              <currency-input
                placeholder="0.00"
                v-model.lazy="filterForm.sumEnd"
                :disabled="!filterForm.sumEnabled"
                class="el-input--small el-input__inner"
                :class="{ moneydisable: !filterForm.sumEnabled }"
                style="width: 100%; height: 36px; line-height: 36px;"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-row type="flex" justify="space-between">
          <el-col :span="24" style="text-align:right;">
            <el-button
              type="primary"
              size="small"
              @click="filterModalSubmit"
              native-type="submit"
              v-shortkey="{ F10: ['f10'] }"
              @shortkey.native="onShortKeyRouter"
              ><span class="key-name">F10</span
              >{{ $t("common.buttons.submit") }}</el-button
            >
            <el-button type="plain" size="small" @click="filterModal = false"
              ><span class="key-name">Esc</span
              >{{ $t("common.buttons.cancel") }}</el-button
            >
          </el-col></el-row
        >
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('common.compliance.modal.title')"
      :visible.sync="complianceModal"
      :close-on-click-modal="false"
      @open="complianceModalShow"
      @close="complianceModalHide"
      :width="dialogWidth"
      class="resize"
      center
      v-draggable
    >
      <el-form :model="complianceForm" label-position="left">
        <el-row type="flex" justify="space-between">
          <el-col :span="1">
            <el-form-item>
              <el-checkbox
                v-model="complianceForm.datesDifferenceEnabled"
              ></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <div>
                {{ $t("common.compliance.form.datesDifference.title") }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-form-item>
              <div>+/-</div>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item>
              <el-input-number
                v-model.lazy="complianceForm.datesDifferenceDays"
                :disabled="!complianceForm.datesDifferenceEnabled"
                :precision="0"
                :controls="false"
                :min="0"
                :max="65535"
                style="width: 170px;"
                size="small"
              ></el-input-number>
              <span style="margin-left: 1em">{{
                $t("common.compliance.form.datesDifference.days")
              }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="1">
            <el-form-item>
              <el-checkbox
                v-model="complianceForm.organizationsMatchEnabled"
              ></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="23">
            <el-form-item>
              <div>
                {{ $t("common.compliance.form.organizationsMatch.title") }}
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="1">
            <el-form-item>
              <el-checkbox
                v-model="complianceForm.paymentMethodsMatchEnabled"
              ></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="23">
            <el-form-item>
              <div>
                {{ $t("common.compliance.form.paymentMethodsMatch.title") }}
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="1">
            <el-form-item>
              <el-checkbox
                v-model="complianceForm.amountDifferenceEnabled"
              ></el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <div>
                {{ $t("common.compliance.form.amountDifference.title") }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="1">
            <el-form-item>
              <div>&nbsp;</div>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item>
              <currency-input
                placeholder="0.00"
                v-model.lazy="complianceForm.amountDifferenceSumma"
                :disabled="!complianceForm.amountDifferenceEnabled"
                class="el-input--small el-input__inner"
                :class="{
                  moneydisable: !complianceForm.amountDifferenceEnabled
                }"
                style="width: 170px; height: 36px; line-height: 36px; margin-right: 5px;"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-row type="flex" justify="space-between">
          <el-col :span="24" style="text-align:right;">
            <el-button
              type="primary"
              size="small"
              @click="complianceModalSubmit"
              v-shortkey="{ F10: ['f10'] }"
              @shortkey.native="onShortKeyRouter"
              ><span class="key-name">F10</span
              >{{ $t("common.buttons.submit") }}</el-button
            >
            <el-button
              type="plain"
              size="small"
              @click="complianceModal = false"
              ><span class="key-name">Esc</span
              >{{ $t("common.buttons.cancel") }}</el-button
            >
          </el-col></el-row
        >
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('relationship.linkForm.modal.title')"
      :visible.sync="linkModal"
      :close-on-click-modal="false"
      @open="linkModalShow"
      @close="linkModalHide"
      :width="largeDialogWidth"
      top="1em"
      v-draggable
    >
      <div class="more-info__inner" ref="moreInfo">
        <el-form
          label-position="left"
          label-width="120px"
          :model="linkForm"
          :rules="linkRules"
          ref="linkForm"
        >
          <el-row type="flex" justify="space-between" style="margin-right: 1em">
            <el-col :span="24">
              <el-card shadow="never">
                <div slot="header">
                  <span class="card-font-header">{{
                    $t("relationship.linkForm.form.cardPayment.header")
                  }}</span>
                </div>
                <el-row type="flex" justify="space-between">
                  <el-col :span="24">
                    <el-form-item
                      :label="$t('relationship.linkForm.form.codefirme.title')"
                    >
                      <el-row type="flex" justify="space-between" :gutter="5">
                        <el-col :span="2">
                          <currency-input
                            placeholder=""
                            v-model="linkForm.payment.codefirmeCode"
                            @blur="onChangeCodefirmeCode"
                            @keyup.enter.native="onChangeCodefirmeCode"
                            :precision="0"
                            disabled
                            class="el-input--small el-input__inner"
                            style="width: 100%; height: 32px; line-height: 32px;"
                            :class="{
                              'not-eqaul-input': linkForm.notEqual.codefirme,
                              moneydisable: true
                            }"
                          />
                        </el-col>

                        <el-col :span="22">
                          <el-select
                            v-model="linkForm.payment.codefirme"
                            :placeholder="
                              $t('common.components.select.placeholder')
                            "
                            clearable
                            filterable
                            style="width: 100%;"
                            disabled
                            :class="{
                              'not-eqaul-select': linkForm.notEqual.codefirme
                            }"
                            size="small"
                          >
                            <el-option
                              v-for="item in params.gfirme.data"
                              :key="item.codefirme"
                              :label="item.namefirme"
                              :value="item.codefirme"
                            ></el-option>
                          </el-select>
                        </el-col>
                      </el-row>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row type="flex" justify="space-between">
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('relationship.linkForm.form.datebank.title')"
                    >
                      <el-date-picker
                        v-model="linkForm.payment.datebank"
                        type="date"
                        :placeholder="
                          $t('common.components.datePicker.placeholder')
                        "
                        format="dd.MM.yyyy"
                        value-format="dd.MM.yyyy"
                        :picker-options="pickerOptions"
                        disabled
                        :class="{
                          'not-eqaul-date': linkForm.notEqual.datebank
                        }"
                        size="small"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" style="text-align:right;">
                    <el-form-item
                      :label="$t('relationship.linkForm.form.datepay.title')"
                    >
                      <el-date-picker
                        v-model="linkForm.payment.datepay"
                        type="date"
                        :placeholder="
                          $t('common.components.datePicker.placeholder')
                        "
                        format="dd.MM.yyyy"
                        value-format="dd.MM.yyyy"
                        :picker-options="pickerOptions"
                        disabled
                        size="small"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row type="flex" justify="space-between">
                  <el-col :span="24">
                    <el-form-item
                      :label="$t('relationship.linkForm.form.summa.title')"
                    >
                      <currency-input
                        placeholder="0.00"
                        v-model.lazy="linkForm.payment.summa"
                        :disabled="true"
                        class="el-input--small el-input__inner moneydisable"
                        :class="{
                          'not-eqaul-input': linkForm.notEqual.summa
                        }"
                        style="width: 220px; height: 32px; line-height: 32px;"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row type="flex" justify="space-between">
                  <el-col :span="24">
                    <el-checkbox v-model="linkForm.payment.status" disabled>{{
                      $t("relationship.linkForm.form.status.title")
                    }}</el-checkbox>
                  </el-col>
                </el-row>
              </el-card>
              <el-card shadow="never" style="margin-top: 10px;">
                <div slot="header">
                  <span class="card-font-header">{{
                    $t("relationship.linkForm.form.cardPack.header")
                  }}</span>
                </div>
                <el-row type="flex" justify="space-between">
                  <el-col :span="24">
                    <el-form-item
                      :label="$t('relationship.linkForm.form.codefirme.title')"
                    >
                      <el-row type="flex" justify="space-between" :gutter="5">
                        <el-col :span="2">
                          <currency-input
                            placeholder=""
                            v-model="linkForm.pack.codefirmeCode"
                            @blur="onChangeCodefirmeCode"
                            @keyup.enter.native="onChangeCodefirmeCode"
                            :precision="0"
                            disabled
                            class="el-input--small el-input__inner"
                            style="width: 100%; height: 32px; line-height: 32px;"
                            :class="{
                              'not-eqaul-input': linkForm.notEqual.codefirme,
                              moneydisable: true
                            }"
                          />
                        </el-col>

                        <el-col :span="22">
                          <el-select
                            v-model="linkForm.pack.codefirme"
                            :placeholder="
                              $t('common.components.select.placeholder')
                            "
                            clearable
                            filterable
                            style="width: 100%;"
                            disabled
                            :class="{
                              'not-eqaul-select': linkForm.notEqual.codefirme
                            }"
                            size="small"
                          >
                            <el-option
                              v-for="item in params.gfirme.data"
                              :key="item.codefirme"
                              :label="item.namefirme"
                              :value="item.codefirme"
                            ></el-option>
                          </el-select>
                        </el-col>
                      </el-row>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row type="flex" justify="space-between">
                  <el-col :span="24">
                    <el-form-item
                      :label="$t('relationship.linkForm.form.datebank.title')"
                    >
                      <el-date-picker
                        v-model="linkForm.pack.datebank"
                        type="date"
                        :placeholder="
                          $t('common.components.datePicker.placeholder')
                        "
                        format="dd.MM.yyyy"
                        value-format="dd.MM.yyyy"
                        :picker-options="pickerOptions"
                        disabled
                        :class="{
                          'not-eqaul-date': linkForm.notEqual.datebank
                        }"
                        size="small"
                      ></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row type="flex" justify="space-between">
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('relationship.linkForm.form.summa.title')"
                    >
                      <currency-input
                        placeholder="0.00"
                        v-model.lazy="linkForm.pack.summa"
                        :disabled="true"
                        class="el-input--small el-input__inner moneydisable"
                        :class="{ 'not-eqaul-input': linkForm.notEqual.summa }"
                        style="width: 220px; height: 32px; line-height: 32px;"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" style="text-align:right;">
                    <el-form-item
                      :label="$t('relationship.linkForm.form.sumprof.title')"
                    >
                      <currency-input
                        placeholder="0.00"
                        v-model.lazy="linkForm.pack.sumprof"
                        :disabled="true"
                        class="el-input--small el-input__inner moneydisable"
                        style="width: 220px; height: 32px; line-height: 32px;"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row type="flex" justify="space-between">
                  <el-col :span="12">
                    <el-form-item
                      :label="$t('relationship.linkForm.form.quantity.title')"
                    >
                      <el-input
                        v-model="linkForm.pack.quantity"
                        disabled
                        style="width: 220px;"
                        size="small"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12" style="text-align:right;">
                    <el-form-item
                      :label="$t('relationship.linkForm.form.countband.title')"
                    >
                      <el-input
                        v-model="linkForm.pack.countband"
                        disabled
                        style="width: 220px;"
                        size="small"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-card>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-between"
            style="margin-top: 1em; margin-right: 1em"
          >
            <el-col :span="24" style="text-align:right;">
              <el-form-item
                :label="$t('relationship.linkForm.form.difference.title')"
                label-width="400px"
              >
                <currency-input
                  placeholder="0.00"
                  v-model.lazy="linkForm.difference"
                  :disabled="true"
                  class="el-input--small el-input__inner moneydisable"
                  :class="{
                    'not-eqaul-difference':
                      linkForm.notEqual.difference === true
                  }"
                  style="width: 220px; height: 32px; line-height: 32px;"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="space-between" style="margin-right: 1em">
            <el-col :span="24">
              <el-form-item
                :label="$t('relationship.linkForm.form.userid.title')"
                label-width="190px"
                prop="userid"
              >
                <el-row type="flex" justify="space-between" :gutter="5">
                  <el-col :span="2">
                    <currency-input
                      placeholder=""
                      v-model="linkForm.useridCode"
                      @blur="onChangeUseridCode"
                      @keyup.enter.native="onChangeUseridCode"
                      :precision="0"
                      class="el-input--small el-input__inner"
                      style="width: 100%; height: 32px; line-height: 32px;"
                    />
                  </el-col>

                  <el-col :span="22">
                    <el-select
                      v-model="linkForm.userid"
                      :placeholder="$t('common.components.select.placeholder')"
                      clearable
                      filterable
                      style="width: 100%;"
                      size="small"
                    >
                      <el-option
                        v-for="item in params.gusersrelpackpay.data"
                        :key="item.userid"
                        :label="item.fio"
                        :value="item.userid"
                      ></el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-row type="flex" justify="space-between">
          <el-col :span="24" style="text-align:right;">
            <el-button
              type="primary"
              size="small"
              @click="linkModalSubmit"
              native-type="submit"
              v-shortkey="{ F10: ['f10'] }"
              @shortkey.native="onShortKeyRouter"
              ><span class="key-name">F10</span
              >{{ $t("common.buttons.submit") }}</el-button
            >
            <el-button type="plain" size="small" @click="linkModal = false"
              ><span class="key-name">Esc</span
              >{{ $t("common.buttons.cancel") }}</el-button
            >
          </el-col></el-row
        >
      </span>
    </el-dialog>

    <el-dialog
      :title="titleEditModal"
      :visible.sync="editModal"
      :close-on-click-modal="false"
      @open="editModalShow"
      @close="editModalHide"
      :width="largeDialogWidth"
      top="1em"
      class="resize"
      center
      v-draggable
    >
      <el-form :model="editForm" :rules="editRules" ref="editForm">
        <el-row type="flex" justify="space-between">
          <el-col :span="12">
            <el-form-item
              :label="$t('packsreceipts.editForm.form.packnumber')"
              label-width="180px"
            >
              <el-input
                v-model="editForm.packnumber"
                clearable
                style="width: 90%;"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="text-align:right;">
            <el-form-item
              prop="datebank"
              :label="$t('packsreceipts.editForm.form.datebank')"
              label-width="160px"
            >
              <el-date-picker
                v-model="editForm.datebank"
                type="date"
                :placeholder="$t('common.components.datePicker.placeholder')"
                format="dd.MM.yyyy"
                value-format="dd.MM.yyyy"
                :picker-options="pickerOptions"
                style="width: 100%;"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="24">
            <el-form-item
              :label="$t('packsreceipts.editForm.form.codefirme')"
              label-width="180px"
            >
              <el-row type="flex" justify="space-between" :gutter="5">
                <el-col :span="4">
                  <el-input
                    v-model="editForm.mfo"
                    clearable
                    style="width: 100%;"
                    @input="onChangeMfo"
                    :disabled="editFieldDisabled"
                  ></el-input>
                </el-col>
                <el-col :span="2">
                  <currency-input
                    placeholder=""
                    v-model="editForm.codefirmeCode"
                    @blur="onChangeCodefirmeCodeEditForm"
                    @keyup.enter.native="onChangeCodefirmeCodeEditForm"
                    :disabled="editFieldDisabled"
                    :precision="0"
                    class="el-input--small el-input__inner"
                    :class="{ moneydisable: editFieldDisabled }"
                    style="width: 100%; height: 37px; line-height: 37px;"
                  />
                </el-col>
                <el-col :span="18">
                  <el-select
                    v-model="editForm.codefirme"
                    :placeholder="$t('common.components.select.placeholder')"
                    clearable
                    filterable
                    style="width: 100%;"
                    :disabled="editFieldDisabled"
                  >
                    <el-option
                      v-for="item in editForm.senders"
                      :key="item.codefirme"
                      :label="item.namefirme"
                      :value="item.codefirme"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="24">
            <el-form-item
              prop="accountSender"
              :label="$t('packsreceipts.editForm.form.accountSender')"
              label-width="180px"
            >
              <el-input
                v-model="editForm.accountSender"
                style="width: 100%;"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="24">
            <el-form-item
              prop="kindpay"
              :label="$t('packsreceipts.editForm.form.kindpay')"
              label-width="180px"
            >
              <el-row type="flex" justify="space-between" :gutter="5">
                <el-col :span="2">
                  <currency-input
                    placeholder=""
                    v-model="editForm.kindpayCode"
                    @blur="onChangeKindpayCode"
                    @keyup.enter.native="onChangeKindpayCode"
                    :disabled="editFieldDisabled"
                    :precision="0"
                    class="el-input--small el-input__inner"
                    :class="{ moneydisable: editFieldDisabled }"
                    style="width: 100%; height: 37px; line-height: 37px;"
                  />
                </el-col>
                <el-col :span="22">
                  <el-select
                    v-model="editForm.kindpay"
                    :placeholder="$t('common.components.select.placeholder')"
                    clearable
                    filterable
                    style="width: 100%;"
                    :disabled="editFieldDisabled"
                  >
                    <el-option
                      v-for="item in editForm.payments"
                      :key="item.kindpay"
                      :label="item.kindname"
                      :value="item.kindpay"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="12">
            <el-form-item
              prop="quantity"
              :label="labelQuantity"
              label-width="180px"
            >
              <el-input-number
                v-model.lazy="editForm.quantity"
                :precision="0"
                :controls="false"
                :min="1"
                :max="65535"
                style="width: 90%;"
                size="small"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="text-align:right;">
            <el-form-item
              prop="countband"
              :label="labelCountband"
              label-width="180px"
            >
              <el-input-number
                v-model.lazy="editForm.countband"
                :disabled="editFieldDisabled"
                :precision="0"
                :controls="false"
                :min="1"
                :max="65535"
                style="width: 90%;"
                size="small"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="space-between">
          <el-col :span="12">
            <el-form-item
              prop="summa"
              :label="$t('packsreceipts.editForm.form.summa')"
              label-width="180px"
            >
              <currency-input
                placeholder="0.00"
                v-model.lazy="editForm.summa"
                class="el-input--small el-input__inner"
                style="width: 90%; height: 36px; line-height: 36px"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12" style="text-align:right;">
            <el-form-item
              v-if="visibleSumprof"
              :label="$t('packsreceipts.editForm.form.sumprof')"
              label-width="180px"
            >
              <currency-input
                placeholder="0.00"
                v-model.lazy="editForm.sumprof"
                class="el-input--small el-input__inner"
                style="width: 90%; height: 36px; line-height: 36px"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="visibleOperator" type="flex" justify="space-between">
          <el-col :span="24">
            <el-form-item
              prop="userid"
              :label="$t('packsreceipts.editForm.form.userid')"
              label-width="180px"
            >
              <el-row type="flex" justify="space-between" :gutter="5">
                <el-col :span="2">
                  <currency-input
                    placeholder=""
                    v-model="editForm.useridCode"
                    @blur="onChangeUseridCodeEditForm"
                    @keyup.enter.native="onChangeUseridCodeEditForm"
                    :precision="0"
                    class="el-input--small el-input__inner"
                    style="width: 100%; height: 37px; line-height: 37px;"
                  />
                </el-col>

                <el-col :span="22">
                  <el-select
                    v-model="editForm.userid"
                    :placeholder="$t('common.components.select.placeholder')"
                    clearable
                    filterable
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in params.guserspackedit.data"
                      :key="item.userid"
                      :label="item.fio"
                      :value="item.userid"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-row type="flex" justify="space-between">
          <el-col :span="12" style="text-align:left;">
            <div v-if="!infoPayBtnDisabled">
              <el-button
                type="primary"
                size="small"
                @click="onClickInfoPay"
                native-type="submit"
                >{{ $t("common.buttons.infoPay") }}</el-button
              >
            </div>
          </el-col>
          <el-col :span="12" style="text-align:right;">
            <el-button
              type="primary"
              size="small"
              @click="editModalSubmit"
              native-type="submit"
              v-shortkey="{ F10: ['f10'] }"
              @shortkey.native="onShortKeyRouter"
              ><span class="key-name">F10</span
              >{{ $t("common.buttons.submit") }}</el-button
            >
            <el-button type="plain" size="small" @click="editModal = false"
              ><span class="key-name">Esc</span
              >{{ $t("common.buttons.cancel") }}</el-button
            >
          </el-col>
        </el-row>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('relationship.searchErrorPaymentsForm.modal.title')"
      :visible.sync="searchErrorPaymentsModal"
      :close-on-click-modal="false"
      @open="searchErrorPaymentsModalShow"
      @close="searchErrorPaymentsModalHide"
      width="55%"
      top="1em"
      v-draggable
    >
      <div class="more-info__inner" ref="searchErrorPayments">
        <el-form
          :model="searchErrorPaymentsForm"
          :rules="searchErrorPaymentsRules"
          ref="searchErrorPaymentsForm"
        >
          <el-row
            type="flex"
            justify="space-between"
            :gutter="5"
            style="margin-right: 1em"
          >
            <el-col :span="5">
              <el-form-item>
                <div>
                  {{ $t("relationship.searchErrorPaymentsForm.form.abcode") }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item>
                <el-input
                  v-model="searchErrorPaymentsForm.abcode"
                  clearable
                  size="small"
                  style="width: 100%;"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <el-form-item>
                <el-select
                  v-model="searchErrorPaymentsForm.abcodeTypeSearch"
                  :placeholder="$t('common.components.select.placeholder')"
                  filterable
                  size="small"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in searchTypesOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-between"
            :gutter="5"
            style="margin-right: 1em"
          >
            <el-col :span="5">
              <el-form-item>
                <div>
                  {{ $t("relationship.searchErrorPaymentsForm.form.sumPay") }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item>
                <el-select
                  v-model="searchErrorPaymentsForm.sumPayTypeSearch"
                  :placeholder="$t('common.components.select.placeholder')"
                  filterable
                  size="small"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in searchDateTypesOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <currency-input
                  placeholder="0.00"
                  v-model.lazy="searchErrorPaymentsForm.sumPayBegin"
                  class="el-input--small el-input__inner"
                  style="width: 100%; height: 32px; line-height: 32px;"
                />
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item
                v-if="searchErrorPaymentsForm.sumPayTypeSearch === '1'"
              >
                <div style="text-align: center;">
                  {{ $t("relationship.searchErrorPaymentsForm.form.and") }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                v-if="searchErrorPaymentsForm.sumPayTypeSearch === '1'"
              >
                <currency-input
                  placeholder="0.00"
                  v-model.lazy="searchErrorPaymentsForm.sumPayEnd"
                  class="el-input--small el-input__inner"
                  style="width: 100%; height: 32px; line-height: 32px;"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-between"
            :gutter="5"
            style="margin-right: 1em"
          >
            <el-col :span="5">
              <el-form-item>
                <div>
                  {{ $t("relationship.searchErrorPaymentsForm.form.dateBank") }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item>
                <el-select
                  v-model="searchErrorPaymentsForm.dateBankTypeSearch"
                  :placeholder="$t('common.components.select.placeholder')"
                  filterable
                  size="small"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in searchDateTypesOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-date-picker
                  v-model="searchErrorPaymentsForm.dateBankBegin"
                  type="date"
                  :placeholder="$t('common.components.datePicker.placeholder')"
                  format="dd.MM.yyyy"
                  value-format="dd.MM.yyyy"
                  :picker-options="pickerOptions"
                  size="small"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item
                v-if="searchErrorPaymentsForm.dateBankTypeSearch === '1'"
              >
                <div style="text-align: center;">
                  {{ $t("relationship.searchErrorPaymentsForm.form.and") }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                v-if="searchErrorPaymentsForm.dateBankTypeSearch === '1'"
              >
                <el-date-picker
                  v-model="searchErrorPaymentsForm.dateBankEnd"
                  type="date"
                  :placeholder="$t('common.components.datePicker.placeholder')"
                  format="dd.MM.yyyy"
                  value-format="dd.MM.yyyy"
                  :picker-options="pickerOptions"
                  size="small"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-between"
            :gutter="5"
            style="margin-right: 1em"
          >
            <el-col :span="5">
              <el-form-item>
                <div>
                  {{ $t("relationship.searchErrorPaymentsForm.form.datePay") }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item>
                <el-select
                  v-model="searchErrorPaymentsForm.datePayTypeSearch"
                  :placeholder="$t('common.components.select.placeholder')"
                  filterable
                  size="small"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in searchDateTypesOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-date-picker
                  v-model="searchErrorPaymentsForm.datePayBegin"
                  type="date"
                  :placeholder="$t('common.components.datePicker.placeholder')"
                  format="dd.MM.yyyy"
                  value-format="dd.MM.yyyy"
                  :picker-options="pickerOptions"
                  size="small"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item
                v-if="searchErrorPaymentsForm.datePayTypeSearch === '1'"
              >
                <div style="text-align: center;">
                  {{ $t("relationship.searchErrorPaymentsForm.form.and") }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                v-if="searchErrorPaymentsForm.datePayTypeSearch === '1'"
              >
                <el-date-picker
                  v-model="searchErrorPaymentsForm.datePayEnd"
                  type="date"
                  :placeholder="$t('common.components.datePicker.placeholder')"
                  format="dd.MM.yyyy"
                  value-format="dd.MM.yyyy"
                  :picker-options="pickerOptions"
                  size="small"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-between"
            :gutter="5"
            style="margin-right: 1em"
          >
            <el-col :span="5">
              <el-form-item>
                <div>
                  {{
                    $t("relationship.searchErrorPaymentsForm.form.dateChange")
                  }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item>
                <el-select
                  v-model="searchErrorPaymentsForm.dateChangeTypeSearch"
                  :placeholder="$t('common.components.select.placeholder')"
                  filterable
                  size="small"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in searchDateTypesOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-date-picker
                  v-model="searchErrorPaymentsForm.dateChangeBegin"
                  type="date"
                  :placeholder="$t('common.components.datePicker.placeholder')"
                  format="dd.MM.yyyy"
                  value-format="dd.MM.yyyy"
                  :picker-options="pickerOptions"
                  size="small"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-form-item
                v-if="searchErrorPaymentsForm.dateChangeTypeSearch === '1'"
              >
                <div style="text-align: center;">
                  {{ $t("relationship.searchErrorPaymentsForm.form.and") }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                v-if="searchErrorPaymentsForm.dateChangeTypeSearch === '1'"
              >
                <el-date-picker
                  v-model="searchErrorPaymentsForm.dateChangeEnd"
                  type="date"
                  :placeholder="$t('common.components.datePicker.placeholder')"
                  format="dd.MM.yyyy"
                  value-format="dd.MM.yyyy"
                  :picker-options="pickerOptions"
                  size="small"
                  style="width: 100%;"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            type="flex"
            justify="space-between"
            :gutter="5"
            style="margin-right: 1em"
          >
            <el-col :span="5">
              <el-form-item>
                <div>
                  {{
                    $t("relationship.searchErrorPaymentsForm.form.errorType")
                  }}
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="19">
              <el-form-item>
                <el-select
                  v-model="searchErrorPaymentsForm.errorType"
                  :placeholder="$t('common.components.select.placeholder')"
                  filterable
                  clearable
                  size="small"
                  style="width: 100%;"
                >
                  <el-option
                    v-for="item in params.statuspay.data"
                    :key="item.coderr"
                    :label="item.nameerr"
                    :value="item.coderr"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div v-if="extendedSearch">
            <el-divider></el-divider>
            <el-row
              type="flex"
              justify="space-between"
              :gutter="5"
              style="margin-right: 1em"
            >
              <el-col :span="5">
                <el-form-item>
                  <div>
                    {{ $t("relationship.searchErrorPaymentsForm.form.npack") }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item>
                  <el-input-number
                    v-model.lazy="searchErrorPaymentsForm.npack"
                    :precision="0"
                    :controls="false"
                    style="width: 100%;"
                    size="small"
                  ></el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item> </el-form-item>
              </el-col>
            </el-row>
            <el-row
              type="flex"
              justify="space-between"
              :gutter="5"
              style="margin-right: 1em"
            >
              <el-col :span="5">
                <el-form-item>
                  <div>
                    {{
                      $t(
                        "relationship.searchErrorPaymentsForm.form.datePayFrom"
                      )
                    }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item>
                  <el-date-picker
                    v-model="searchErrorPaymentsForm.datePayFrom"
                    type="date"
                    :placeholder="
                      $t('common.components.datePicker.placeholder')
                    "
                    format="dd.MM.yyyy"
                    value-format="dd.MM.yyyy"
                    :picker-options="pickerOptions"
                    size="small"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="1" style="text-align:right;">
                <el-form-item>
                  <div>
                    {{
                      $t("relationship.searchErrorPaymentsForm.form.datePayTo")
                    }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="9">
                <el-form-item>
                  <el-date-picker
                    v-model="searchErrorPaymentsForm.datePayTo"
                    type="date"
                    :placeholder="
                      $t('common.components.datePicker.placeholder')
                    "
                    format="dd.MM.yyyy"
                    value-format="dd.MM.yyyy"
                    :picker-options="pickerOptions"
                    size="small"
                    style="width: 100%;"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              type="flex"
              justify="space-between"
              :gutter="5"
              style="margin-right: 1em"
            >
              <el-col :span="5">
                <el-form-item>
                  <div>
                    {{
                      $t("relationship.searchErrorPaymentsForm.form.kindpay")
                    }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="19">
                <el-form-item>
                  <el-select
                    v-model="searchErrorPaymentsForm.kindpay"
                    :placeholder="$t('common.components.select.placeholder')"
                    filterable
                    clearable
                    size="small"
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in params.gkindpay.data"
                      :key="item.kindpay"
                      :label="item.kindname"
                      :value="item.kindpay"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              type="flex"
              justify="space-between"
              :gutter="5"
              style="margin-right: 1em"
            >
              <el-col :span="5">
                <el-form-item>
                  <div>
                    {{
                      $t("relationship.searchErrorPaymentsForm.form.codefirme")
                    }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="19">
                <el-form-item>
                  <el-select
                    v-model="searchErrorPaymentsForm.codefirme"
                    :placeholder="$t('common.components.select.placeholder')"
                    filterable
                    clearable
                    size="small"
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in params.gfirme.data"
                      :key="item.codefirme"
                      :label="item.namefirme"
                      :value="item.codefirme"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              type="flex"
              justify="space-between"
              :gutter="5"
              style="margin-right: 1em"
            >
              <el-col :span="5">
                <el-form-item>
                  <div>
                    {{ $t("relationship.searchErrorPaymentsForm.form.note") }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item>
                  <el-input
                    v-model="searchErrorPaymentsForm.note"
                    clearable
                    size="small"
                    style="width: 100%;"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item>
                  <el-select
                    v-model="searchErrorPaymentsForm.noteTypeSearch"
                    :placeholder="$t('common.components.select.placeholder')"
                    filterable
                    size="small"
                    style="width: 100%;"
                  >
                    <el-option
                      v-for="item in searchTypesOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-row type="flex" justify="space-between">
          <el-col :span="12" style="text-align:left;">
            <el-checkbox
              v-model="extendedSearch"
              v-shortkey="{ F2: ['f2'] }"
              @shortkey.native="onShortKeyRouter"
              >{{
                $t("relationship.searchErrorPaymentsForm.extendedSearch")
              }}</el-checkbox
            >
          </el-col>
          <el-col :span="12" style="text-align:right;">
            <el-button
              type="primary"
              size="small"
              @click="searchErrorPaymentsFormSubmit"
              native-type="submit"
              v-shortkey="{ F10: ['f10'] }"
              @shortkey.native="onShortKeyRouter"
              ><span class="key-name">F10</span
              >{{ $t("common.buttons.submit") }}</el-button
            >
            <el-button
              type="plain"
              size="small"
              @click="searchErrorPaymentsModal = false"
              ><span class="key-name">Esc</span
              >{{ $t("common.buttons.cancel") }}</el-button
            >
          </el-col>
        </el-row>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('errorPayments.errorPaymentsForm.modal.title')"
      :visible.sync="errorPaymentsModal"
      :close-on-click-modal="false"
      @close="errorPaymentsModalHide"
      fullscreen
    >
      <el-row type="flex" justify="space-between">
        <el-col :span="24">
          <div class="grid-error-container-modal">
            <ag-grid-vue
              style="width: 100%; height: 100%; text-align: center; font-family: 'Open Sans', sans-serif;"
              class="ag-theme-balham"
              rowSelection="single"
              :defaultColDef="defaultColDef"
              :columnDefs="errorPaymentsColumnDefs"
              :rowData="paymentErrors"
              :gridOptions="errorPaymentsGridOptions"
              @grid-ready="onPaymentErrorsGridReady"
              @first-data-rendered="onFirstPaymentErrorsDataRendered"
              @modelUpdated="onErrorPaymentsModelUpdated"
              @rowSelected="onErrorPaymentsRowSelected"
              @rowDoubleClicked="onErrorPaymentsRowDoubleClicked"
              @cellContextMenu="onPaymentErrorsRowRightClicked"
            ></ag-grid-vue>
          </div>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-between" style="margin-top: 10px;">
        <el-col :span="24">
          <el-checkbox
            v-model="autoDistributeCheckbox"
            v-shortkey="{ F2: ['f2'] }"
            @shortkey.native="onShortKeyRouter"
          >
            {{ $t("errorPayments.errorPaymentsForm.autoDistribute") }}
          </el-checkbox>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-row type="flex" justify="space-between">
          <el-col :span="12" style="text-align:left;">
            <el-button
              type="primary"
              size="small"
              @click="onClickErrorPaymentChangeBtn('edit')"
              :disabled="fixBtnDisabled"
              v-shortkey="{ Enter: ['enter'], F4: ['f4'] }"
              @shortkey.native="onShortKeyRouter"
              ><span class="key-name">F4</span
              >{{ $t("common.buttons.fix") }}</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="onClickErrorPaymentChangeBtn('del')"
              :disabled="removeBtnDisabled"
              v-shortkey="{ Del: ['del'], Minus: ['-'] }"
              @shortkey.native="onShortKeyRouter"
              ><span class="key-name">Del</span
              >{{ $t("common.buttons.remove") }}</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="onClickErrorPaymentDistributeBtn"
              :disabled="distributeBtnDisabled"
              v-shortkey="{ F9: ['f9'] }"
              @shortkey.native="onShortKeyRouter"
              ><span class="key-name">F9</span
              >{{ $t("common.buttons.distribute") }}</el-button
            >
          </el-col>
          <el-col :span="12" style="text-align:right;">
            <el-button
              type="plain"
              size="small"
              @click="errorPaymentsModal = false"
              ><span class="key-name">Esc</span
              >{{ $t("common.buttons.close") }}</el-button
            >
          </el-col>
        </el-row>
      </span>
    </el-dialog>

    <Payment></Payment>
  </div>
</template>

<script>
import { nameFirme, kindName, sortSum, formatSum } from "@/helpers/reference";
import { mapActions, mapGetters } from "vuex";
import { AgGridVue } from "ag-grid-vue";
import agGridLocaleRu from "@/locales/ru/agGrid";
import agGridLocaleUa from "@/locales/ua/agGrid";
import agGridLocaleEn from "@/locales/en/agGrid";
import i18n from "@/locales";
import { $, gt } from "moneysafe";
import Payment from "@/components/Payment";
import { setGridView } from "@/helpers/grid";
import { pickerOptions } from "@/mixins/pickerOptions";
import { dialogWidth } from "@/mixins/dialogWidth";
import { checkAccess } from "@/helpers/access";

export default {
  name: "relationship",
  components: {
    AgGridVue,
    Payment
  },
  mixins: [pickerOptions, dialogWidth],
  data() {
    const validateDateRange = (rule, value, callback) => {
      if (this.filterForm.dateEnabled && !value) {
        callback(new Error(this.$t("common.validations.dateRange.message")));
      } else {
        callback();
      }
    };
    const validateOrganizationCode = (rule, value, callback) => {
      if (this.filterForm.organizationEnabled && !value) {
        callback(
          new Error(this.$t("common.validations.confirmeCodefirme.message"))
        );
      } else {
        callback();
      }
    };
    const validatePaymentCode = (rule, value, callback) => {
      if (this.filterForm.paymentEnabled && !value) {
        callback(new Error(this.$t("common.validations.payment.message")));
      } else {
        callback();
      }
    };
    const validateSumRange = (rule, value, callback) => {
      if (
        this.filterForm.sumEnabled &&
        gt($(this.filterForm.sumBegin), $(this.filterForm.sumEnd))
      ) {
        callback(new Error(this.$t("common.validations.sumRange.message")));
      } else {
        callback();
      }
    };
    const validateUser = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("common.validations.userPayment.message")));
      } else {
        callback();
      }
    };
    const validateDatebank = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("common.validations.datebank.message")));
      } else {
        callback();
      }
    };
    const validateRcount = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("common.validations.rcount.message")));
      } else {
        callback();
      }
    };
    const validatePayment = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("common.validations.payment.message")));
      } else {
        callback();
      }
    };
    const validateSummaPack = (rule, value, callback) => {
      const kind = this.params.gkindpay.data.filter(
        item => item.kindpay === this.editForm.kindpay
      );
      const negsum = kind.length > 0 ? kind[0].negsum : "";
      if (value < 0 && negsum === "0") {
        callback(new Error(this.$t("common.validations.summaPack.aboveZero")));
      } else if (value === 0 && this.params.goptions.allowzeropays !== "yes") {
        callback(
          new Error(this.$t("common.validations.summaPack.notEqualZero"))
        );
      } else {
        callback();
      }
    };
    const validateUserPayment = (rule, value, callback) => {
      if (this.visibleOperator && !value) {
        callback(new Error(this.$t("common.validations.userPayment.message")));
      } else {
        callback();
      }
    };
    return {
      agGridlocaleText: null,
      paymentsRelationGridOptions: null,
      paymentsRelationGridApi: null,
      paymentsRelationColumnApi: null,
      packsRelationGridOptions: null,
      packsRelationGridApi: null,
      packsRelationColumnApi: null,
      errorPaymentsGridOptions: null,
      errorPaymentsGridApi: null,
      errorPaymentsColumnApi: null,
      defaultColDef: {
        resizable: true,
        sortable: true,
        filter: true,
        autoHeight: false,
        filterParams: {
          applyButton: false,
          clearButton: true
        },
        headerClass: "ag-grid-header",
        cellClass: "ag-grid-cell"
      },
      packsSource: null,
      paymentsRelationColumnDefs: [
        {
          headerName: this.$t(
            "relationship.paymentsRelationColumn.headers.paymentsRelation"
          ),
          headerTooltip: this.$t(
            "relationship.paymentsRelationColumn.headers.paymentsRelation"
          ),
          children: [
            {
              headerName: this.$t("common.gridColumns.nameaccount"),
              headerTooltip: this.$t("common.gridColumns.nameaccount"),
              field: "nameaccount",
              tooltipField: "nameaccount"
            },
            {
              headerName: this.$t("common.gridColumns.namefirmeSenderPay"),
              headerTooltip: this.$t("common.gridColumns.namefirmeSenderPay"),
              field: "namefirme",
              tooltipField: "namefirme"
            },
            {
              headerName: this.$t("common.gridColumns.okpo"),
              headerTooltip: this.$t("common.gridColumns.okpo"),
              field: "okpo",
              tooltipField: "okpo"
            },
            {
              headerName: this.$t("common.gridColumns.datepay"),
              headerTooltip: this.$t("common.gridColumns.datepay"),
              field: "datepay",
              sort: "asc",
              tooltipField: "datepay",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            },
            {
              headerName: this.$t("common.gridColumns.datebankPay"),
              headerTooltip: this.$t("common.gridColumns.datebankPay"),
              field: "datebank",
              tooltipField: "datebank",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            },
            {
              headerName: this.$t("common.gridColumns.kindname"),
              headerTooltip: this.$t("common.gridColumns.kindname"),
              field: "kindname",
              tooltipField: "kindname"
            },
            {
              headerName: this.$t("common.gridColumns.summa"),
              headerTooltip: this.$t("common.gridColumns.summa"),
              field: "summa",
              tooltipField: "summa",
              cellClass: "sum-column",
              valueFormatter: params => formatSum(params.value),
              comparator: (sum1, sum2) => sortSum(sum1, sum2)
            },
            {
              headerName: this.$t("common.gridColumns.paynumber"),
              headerTooltip: this.$t("common.gridColumns.paynumber"),
              field: "paynumber",
              tooltipField: "paynumber"
            },
            {
              headerName: this.$t("common.gridColumns.astatus"),
              headerTooltip: this.$t("common.gridColumns.astatus"),
              field: "status",
              tooltipValueGetter: params =>
                params.value === "1"
                  ? this.$t("common.types.astatus.yes")
                  : this.$t("common.types.astatus.no"),
              cellRenderer: function(params) {
                return params.value === "1"
                  ? "<input type=checkbox checked disabled>"
                  : "<input type=checkbox disabled>";
              }
            },
            {
              headerName: this.$t("common.gridColumns.mess"),
              headerTooltip: this.$t("common.gridColumns.mess"),
              field: "mess",
              tooltipField: "mess"
            }
          ]
        }
      ],
      packsRelationColumnDefs: [
        {
          headerName: this.$t(
            "relationship.packsRelationColumn.headers.packsRelation"
          ),
          headerTooltip: this.$t(
            "relationship.packsRelationColumn.headers.packsRelation"
          ),
          children: [
            {
              headerName: this.$t("common.gridColumns.namefirmeSender"),
              headerTooltip: this.$t("common.gridColumns.namefirmeSender"),
              field: "namefirme",
              tooltipField: "namefirme",
              sort: "asc"
            },
            {
              headerName: this.$t("common.gridColumns.datebank"),
              headerTooltip: this.$t("common.gridColumns.datebank"),
              field: "datebank",
              tooltipField: "datebank",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            },
            {
              headerName: this.$t("common.gridColumns.kindname"),
              headerTooltip: this.$t("common.gridColumns.kindname"),
              field: "kindname",
              tooltipField: "kindname"
            },
            {
              headerName: this.$t("common.gridColumns.countband"),
              headerTooltip: this.$t("common.gridColumns.countband"),
              field: "countband",
              tooltipField: "countband",
              comparator: (value1, value2) =>
                parseInt(value1) - parseInt(value2)
            },
            {
              headerName: this.$t("common.gridColumns.quantity"),
              headerTooltip: this.$t("common.gridColumns.quantity"),
              field: "quantity",
              tooltipField: "quantity",
              comparator: (value1, value2) =>
                parseInt(value1) - parseInt(value2)
            },
            {
              headerName: this.$t("common.gridColumns.summa"),
              headerTooltip: this.$t("common.gridColumns.summa"),
              field: "summa",
              tooltipField: "summa",
              cellClass: "sum-column",
              valueFormatter: params => formatSum(params.value),
              comparator: (sum1, sum2) => sortSum(sum1, sum2)
            },
            {
              headerName: this.$t("common.gridColumns.sumprof"),
              headerTooltip: this.$t("common.gridColumns.sumprof"),
              field: "sumprof",
              tooltipField: "sumprof",
              cellClass: "sum-column",
              valueFormatter: params => formatSum(params.value),
              comparator: (sum1, sum2) => sortSum(sum1, sum2)
            },
            {
              headerName: this.$t("common.gridColumns.sumwithoutprof"),
              headerTooltip: this.$t("common.gridColumns.sumwithoutprof"),
              field: "sumwithoutprof",
              tooltipField: "sumwithoutprof",
              cellClass: "sum-column",
              valueFormatter: params => formatSum(params.value),
              comparator: (sum1, sum2) => sortSum(sum1, sum2)
            },
            {
              headerName: this.$t("common.gridColumns.username"),
              headerTooltip: this.$t("common.gridColumns.username"),
              field: "username",
              tooltipField: "username"
            }
          ]
        }
      ],
      packsInternetRelationColumnDefs: [
        {
          headerName: this.$t(
            "relationship.packsInternetRelationColumn.headers.packsInternetRelation"
          ),
          headerTooltip: this.$t(
            "relationship.packsInternetRelationColumn.headers.packsInternetRelation"
          ),
          children: [
            {
              headerName: this.$t("common.gridColumns.namefirmeSender"),
              headerTooltip: this.$t("common.gridColumns.namefirmeSender"),
              field: "namefirme",
              tooltipField: "namefirme",
              sort: "asc"
            },
            {
              headerName: this.$t("common.gridColumns.datepay"),
              headerTooltip: this.$t("common.gridColumns.datepay"),
              field: "dateclient",
              tooltipField: "dateclient",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            },
            {
              headerName: this.$t("common.gridColumns.totalSumma"),
              headerTooltip: this.$t("common.gridColumns.totalSumma"),
              field: "summpay",
              tooltipField: "summpay",
              cellClass: "sum-column",
              valueFormatter: params => formatSum(params.value),
              comparator: (sum1, sum2) => sortSum(sum1, sum2)
            },
            {
              headerName: this.$t("common.gridColumns.summtrans"),
              headerTooltip: this.$t("common.gridColumns.summtrans"),
              field: "summtrans",
              tooltipField: "summtrans",
              cellClass: "sum-column",
              valueFormatter: params => formatSum(params.value),
              comparator: (sum1, sum2) => sortSum(sum1, sum2)
            },
            {
              headerName: this.$t("common.gridColumns.quantity"),
              headerTooltip: this.$t("common.gridColumns.quantity"),
              field: "countpay",
              tooltipField: "countpay",
              comparator: (value1, value2) =>
                parseInt(value1) - parseInt(value2)
            },
            {
              headerName: this.$t("common.gridColumns.transferid"),
              headerTooltip: this.$t("common.gridColumns.transferid"),
              field: "transferid",
              tooltipField: "transferid",
              comparator: (value1, value2) =>
                parseInt(value1) - parseInt(value2)
            }
          ]
        }
      ],
      errorPaymentsColumnDefs: [
        {
          headerName: this.$t("common.gridColumns.payment"),
          headerTooltip: this.$t("common.gridColumns.payment"),
          children: [
            {
              headerName: this.$t("common.gridColumns.abcodeLong"),
              headerTooltip: this.$t("common.gridColumns.abcodeLong"),
              field: "abcode",
              tooltipField: "abcode"
            },
            {
              headerName: this.$t("common.gridColumns.error"),
              headerTooltip: this.$t("common.gridColumns.error"),
              field: "errorname",
              tooltipField: "errorname"
            },
            {
              headerName: this.$t("common.gridColumns.kindname"),
              headerTooltip: this.$t("common.gridColumns.kindname"),
              field: "kindname",
              tooltipField: "kindname"
            },
            {
              headerName: this.$t("common.gridColumns.npack"),
              headerTooltip: this.$t("common.gridColumns.npack"),
              field: "npack",
              tooltipField: "npack"
            },
            {
              headerName: this.$t("common.gridColumns.sumorig"),
              headerTooltip: this.$t("common.gridColumns.sumorig"),
              field: "sumorig",
              tooltipField: "sumorig",
              cellClass: "sum-column",
              valueFormatter: params => formatSum(params.value),
              comparator: (sum1, sum2) => sortSum(sum1, sum2)
            },
            {
              headerName: this.$t("common.gridColumns.currencyname"),
              headerTooltip: this.$t("common.gridColumns.currencyname"),
              field: "currencyname",
              tooltipField: "currencyname"
            },
            {
              headerName: this.$t("common.gridColumns.summa"),
              headerTooltip: this.$t("common.gridColumns.summa"),
              field: "summpay",
              tooltipField: "summpay",
              cellClass: "sum-column",
              valueFormatter: params => formatSum(params.value),
              comparator: (sum1, sum2) => sortSum(sum1, sum2)
            },
            {
              headerName: this.$t("common.gridColumns.datepay"),
              headerTooltip: this.$t("common.gridColumns.datepay"),
              field: "dateclient",
              tooltipField: "dateclient",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            },
            {
              headerName: this.$t("common.gridColumns.datebank"),
              headerTooltip: this.$t("common.gridColumns.datebank"),
              field: "datebank",
              tooltipField: "datebank",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            },
            {
              headerName: this.$t("common.gridColumns.bank"),
              headerTooltip: this.$t("common.gridColumns.bank"),
              field: "namefirme",
              tooltipField: "namefirme"
            },
            {
              headerName: this.$t("common.gridColumns.payname"),
              headerTooltip: this.$t("common.gridColumns.payname"),
              field: "payname",
              tooltipField: "payname"
            },
            {
              headerName: this.$t("common.gridColumns.mess"),
              headerTooltip: this.$t("common.gridColumns.mess"),
              field: "prim",
              tooltipField: "prim"
            }
          ]
        },
        {
          headerName: this.$t("common.gridColumns.validity"),
          headerTooltip: this.$t("common.gridColumns.validity"),
          children: [
            {
              headerName: this.$t("common.gridColumns.datebegin"),
              headerTooltip: this.$t("common.gridColumns.datebegin"),
              field: "datebegin",
              tooltipField: "datebegin",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            },
            {
              headerName: this.$t("common.gridColumns.dateend"),
              headerTooltip: this.$t("common.gridColumns.dateend"),
              field: "dateend",
              tooltipField: "dateend",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            }
          ]
        },
        {
          headerName: this.$t("common.gridColumns.makingEntry"),
          headerTooltip: this.$t("common.gridColumns.makingEntry"),
          children: [
            {
              headerName: this.$t("common.gridColumns.datebeginfact"),
              headerTooltip: this.$t("common.gridColumns.datebeginfact"),
              field: "datebeginfact",
              tooltipField: "datebeginfact",
              comparator: (date1, date2) =>
                parseInt(this.$moment(date1, "DD.MM.YYYY").unix()) -
                parseInt(this.$moment(date2, "DD.MM.YYYY").unix())
            },
            {
              headerName: this.$t("common.gridColumns.username"),
              headerTooltip: this.$t("common.gridColumns.username"),
              field: "username",
              tooltipField: "username"
            }
          ]
        }
      ],
      filterType: "primary",
      filterModal: false,
      filterForm: {
        dateEnabled: null,
        dateRange: [],
        organizationEnabled: null,
        organizationCode: null,
        paymentEnabled: null,
        paymentCode: null,
        sumEnabled: null,
        sumBegin: 0,
        sumEnd: 0
      },
      filterRules: {
        dateRange: [{ validator: validateDateRange, trigger: "blur" }],
        organizationCode: [
          { validator: validateOrganizationCode, trigger: "blur" }
        ],
        paymentCode: [{ validator: validatePaymentCode, trigger: "blur" }],
        sumRange: [{ validator: validateSumRange, trigger: "blur" }]
      },
      complianceModal: false,
      complianceForm: {
        datesDifferenceEnabled: null,
        datesDifferenceDays: null,
        organizationsMatchEnabled: null,
        paymentMethodsMatchEnabled: null,
        amountDifferenceEnabled: null,
        amountDifferenceSumma: null
      },
      linkBtnDisabled: false,
      linkAndPostingBtnVisibled: false,
      packForPaymentBtnVisibled: false,
      packForPaymentBtnDisabled: false,
      linkModal: false,
      linkForm: {
        payment: {
          codefirmeCode: null,
          codefirme: null,
          datebank: null,
          datepay: null,
          summa: 0,
          status: null
        },
        pack: {
          codefirmeCode: null,
          codefirme: null,
          datebank: null,
          summa: 0,
          quantity: null,
          sumprof: null,
          countband: null
        },
        notEqual: {
          codefirme: false,
          datebank: false,
          summa: 0,
          difference: false
        },
        difference: null,
        useridCode: null,
        userid: null
      },
      linkRules: {
        userid: [{ validator: validateUser, trigger: "blur" }]
      },
      money: {
        decimal: ".",
        thousands: " ",
        precision: 2
      },
      currentPayRowSelected: null,
      currentPackRowSelected: null,
      callPosting: false,
      linkConfirmModal: false,
      linkSubmitModal: false,

      // Информация о пачке/субсидии
      editModal: false,
      titleEditModal: null,
      labelQuantity: null,
      labelCountband: null,
      visibleSumprof: true,
      visibleOperator: false,
      editFieldDisabled: true,
      infoPayBtnDisabled: true,
      paymentNotify: null,
      editForm: {
        isimport: null,
        packnumber: null,
        datebank: null,
        mfo: null,
        codefirmeCode: null,
        codefirme: null,
        senders: [],
        accountSender: null,
        kindpayCode: null,
        kindpay: null,
        payments: [],
        quantity: null,
        countband: null,
        summa: 0,
        sumprof: 0,
        paysheetid: null,
        datebeginfact: null,
        npack: null,
        useridCode: null,
        userid: null,
        infoPay: ""
      },
      editRules: {
        datebank: [
          { required: true, validator: validateDatebank, trigger: "blur" }
        ],
        accountSender: [
          { required: true, validator: validateRcount, trigger: "blur" }
        ],
        kindpay: [
          { required: true, validator: validatePayment, trigger: "blur" }
        ],
        quantity: [
          {
            required: true,
            message: this.$t("common.validations.quantity.required"),
            trigger: "blur"
          }
        ],
        countband: [
          {
            required: true,
            message: this.$t("common.validations.countband.required"),
            trigger: "blur"
          }
        ],
        summa: [
          { required: true, validator: validateSummaPack, trigger: "blur" }
        ],
        userid: [
          { required: true, validator: validateUserPayment, trigger: "blur" }
        ]
      },
      modifyModal: false,
      statusCheck: null,
      packLastRow: null,

      // форма Ошибочные платежи
      errorPaymentsModal: false,
      currentErrorPaymentRowSelected: null,
      fixBtnDisabled: true,
      removeBtnDisabled: true,
      distributeBtnDisabled: true,
      autoDistributeCheckbox: false,
      paymentErrorsLastRow: null,

      // форма Поиск ошибочного платежа
      searchErrorPaymentsModal: false,
      searchErrorPaymentsForm: {
        abcode: "",
        abcodeTypeSearch: "1",
        sumPayBegin: 0,
        sumPayEnd: 0,
        sumPayTypeSearch: "0",
        dateBankBegin: "",
        dateBankEnd: "",
        dateBankTypeSearch: "0",
        datePayBegin: "",
        datePayEnd: "",
        datePayTypeSearch: "0",
        dateChangeBegin: "",
        dateChangeEnd: "",
        dateChangeTypeSearch: "0",
        errorType: null,
        npack: null,
        datePayFrom: "",
        datePayTo: "",
        kindpay: null,
        codefirme: null,
        note: "",
        noteTypeSearch: "1"
      },
      searchErrorPaymentsRules: {},
      extendedSearch: false,
      searchTypesOptions: [
        {
          value: "0",
          label: this.$t("common.options.searchTypes.matches")
        },
        {
          value: "1",
          label: this.$t("common.options.searchTypes.contains")
        },
        {
          value: "2",
          label: this.$t("common.options.searchTypes.startsOn")
        },
        {
          value: "3",
          label: this.$t("common.options.searchTypes.endsOn")
        }
      ],
      searchDateTypesOptions: [
        {
          value: "0",
          label: this.$t("common.options.searchDateTypes.equal")
        },
        {
          value: "1",
          label: this.$t("common.options.searchDateTypes.between")
        }
      ],
      calcStorageKey: ""
    };
  },
  computed: {
    ...mapGetters([
      "user",
      "relationshipFilter",
      "relationshipCompliance",
      "paymentsRelationship",
      "packsRelationship",
      "relationshipReloadAllGrids",
      "postingRelationship",
      "paymentPostingError",
      "statusModifyPacksReceipts",
      "paymentModal",
      "paymentErrors",
      "paymentRefreshErrors",
      "statusAddBand",
      "initPage",
      "loading",
      "params"
    ]),
    organizationName: function() {
      const code = this.relationshipFilter.organization.code;
      return code ? nameFirme(this.params.gfirme.data, code) : "";
    },
    paymentName: function() {
      const code = this.relationshipFilter.payment.code;
      return code ? kindName(this.params.gkindpay.data, code) : "";
    },
    checkAllModal: function() {
      return (
        !this.filterModal &&
        !this.editModal &&
        !this.complianceModal &&
        !this.linkModal &&
        !this.linkConfirmModal &&
        !this.linkSubmitModal &&
        !this.paymentModal &&
        !this.errorPaymentsModal &&
        !this.modifyModal &&
        !this.searchErrorPaymentsModal
      );
    }
  },
  watch: {
    relationshipReloadAllGrids: function(value) {
      this.linkModal = false;
      if (value) {
        // для Связать и разнести
        if (this.callPosting) {
          const { npack } = this.currentPackRowSelected;

          this.$store.commit("setPostingRelationship", null);
          this.$store.dispatch("postingRelationship", { npack });
        } else {
          this.getPaymentsRelationship();

          if (this.editModal) {
            this.editModal = false;
            this.$store.commit("setPaymentModal", true);
          }
        }
      }
    },
    postingRelationship: function(value) {
      if (value) {
        this.$alert(value.message, this.$t("relationship.linkResultTitle"), {
          confirmButtonText: "OK",
          type: value.type,
          callback: () => {
            this.getPaymentsRelationship();

            if (value.type === "warning") {
              this.searchErrorPaymentsForm = {
                abcode: "",
                abcodeTypeSearch: "1",
                sumPayBegin: 0,
                sumPayEnd: 0,
                sumPayTypeSearch: "0",
                dateBankBegin: "",
                dateBankEnd: "",
                dateBankTypeSearch: "0",
                datePayBegin: "",
                datePayEnd: "",
                datePayTypeSearch: "0",
                dateChangeBegin: "",
                dateChangeEnd: "",
                dateChangeTypeSearch: "0",
                errorType: null,
                npack: value.npack, // номер пачки
                datePayFrom: "",
                datePayTo: "",
                kindpay: null,
                codefirme: null,
                note: "",
                noteTypeSearch: "1"
              };

              this.getErrorPayments();
              this.errorPaymentsModal = true;
            }
          }
        });
      }
    },
    paymentPostingError: function(value) {
      if (value) {
        this.$alert(value.message, this.$t("relationship.linkResultTitle"), {
          confirmButtonText: "OK",
          type: value.type,
          callback: () => {
            this.getErrorPayments();
          }
        });
      }
    },
    "editForm.datebank": function(date) {
      if (date) {
        const currentDate = parseInt(this.$moment(date, "DD.MM.YYYY").unix());
        this.editForm.senders = this.params.gfirme.data.filter(
          item =>
            currentDate >=
              parseInt(this.$moment(item.datebegin, "DD.MM.YYYY").unix()) &&
            currentDate <=
              parseInt(this.$moment(item.dateend, "DD.MM.YYYY").unix()) &&
            ["1", "2", "4"].includes(item.codegroup)
        );
      } else {
        // this.editForm.mfo = "";
        // this.editForm.codefirme = null;
        // this.editForm.senders = [];
        // this.editForm.accountSender = "";
      }
    },
    "editForm.codefirme": function(codefirme) {
      this.editForm.codefirmeCode = +codefirme || null;
      if (codefirme) {
        const gfirme = this.params.gfirme.data.filter(
          item => item.codefirme === codefirme
        );
        this.editForm.mfo = gfirme.length > 0 ? gfirme[0].mfo : "";
        this.editForm.accountSender = gfirme.length > 0 ? gfirme[0].rcount : "";
      } else {
        this.editForm.mfo = "";
        this.editForm.accountSender = "";
      }
    },
    "editForm.kindpay": function(kindpay) {
      this.editForm.kindpayCode = +kindpay || null;

      if (kindpay && ["88", "91", "99"].includes(kindpay)) {
        this.visibleSumprof = false;
        this.visibleOperator = true;
        this.labelQuantity = this.$t(
          "packsreceipts.editForm.form.quantity.numberSubscribers"
        );
        this.labelCountband = this.$t(
          "packsreceipts.editForm.form.countband.numberSheets"
        );

        switch (kindpay) {
          case "88":
            this.titleEditModal = this.$t(
              "packsreceipts.editForm.modal.title.compensationVisually"
            );
            break;
          case "91":
            this.titleEditModal = this.$t(
              "packsreceipts.editForm.modal.title.socialSupplementInfo"
            );
            break;
          case "99":
            this.titleEditModal = this.$t(
              "packsreceipts.editForm.modal.title.grantInfo"
            );
            break;
        }
      } else {
        this.visibleSumprof = true;
        this.visibleOperator = false;
        this.labelQuantity = this.$t(
          "packsreceipts.editForm.form.quantity.numberReceipts"
        );
        this.labelCountband = this.$t(
          "packsreceipts.editForm.form.countband.numberCountband"
        );

        this.titleEditModal = this.$t(
          "packsreceipts.editForm.modal.title.packageInfo"
        );
      }
    },
    "editForm.userid": function(value) {
      this.editForm.useridCode = +value || null;
    },
    "linkForm.userid": function(value) {
      this.linkForm.useridCode = +value || null;
    },
    "linkForm.payment.codefirme": function(value) {
      this.linkForm.payment.codefirmeCode = +value || null;
    },
    "linkForm.pack.codefirme": function(value) {
      this.linkForm.pack.codefirmeCode = +value || null;
    },
    statusModifyPacksReceipts: async function(value) {
      if (value && value.hasOwnProperty("question")) {
        this.statusCheck = null;

        this.modifyModal = true;
        for (const item of value.question) {
          try {
            await this.$confirm(
              item,
              this.$t("packsreceipts.statusModify.add"),
              {
                confirmButtonText: this.$t("common.buttons.confirmYes"),
                cancelButtonText: this.$t("common.buttons.confirmNo"),
                cancelButtonClass: "cancel-button",
                type: "warning"
              }
            );
            this.statusCheck = true;
          } catch {
            this.statusCheck = false;
          }
          if (!this.statusCheck) break;
        }
        this.modifyModal = false;

        if (this.statusCheck) {
          // 2-й этап создания пачки, confirm = "1", после ответов на вопросы
          this.confirmAdd("1");
        }
      } else if (value && value.hasOwnProperty("rows")) {
        this.packLastRow = value.hasOwnProperty("lastrow")
          ? value.lastrow.toString()
          : "";

        const npack = this.packLastRow;
        const countpay = this.editForm.quantity;
        const summband = this.editForm.summa;
        const sumprof = this.editForm.sumprof;
        const datebank = this.editForm.datebank;
        const kindpay = this.editForm.kindpay;
        const note = this.editForm.infoPay;

        const payload = {
          state: "add",
          npack,
          payid: "", // поле только для редактирования и удаления платежей
          date: datebank,
          sumPay: summband,
          kindpay,
          countpay, // поле только для добавления платежей на 3-й форме
          note
        };
        this.$store.commit("setPaymentData", payload);

        this.$store.commit("clearStatusAddBand");
        await this.$store.dispatch("addBand", {
          npack,
          nband: "1", // уточнение алгоритма от 24.08.2021, для 3-ой формы Кол-во бандеролей всегда должно быть = 1
          countpay,
          summband,
          sumprof
        });
      }
    },
    statusAddBand: function(value) {
      if (value) {
        // Убираем вызов script: "wblink", funcname: "wbRunLink"  при создании пачки по платежу
        // this.getPaymentsRelationship();

        // if (this.editModal) {
        //   this.editModal = false;
        //   this.$store.commit("setPaymentModal", true);
        // }

        const inetpay = "0";
        const paysheetid = this.editForm.paysheetid;
        const transferid = "";
        const userid = this.editForm.userid;
        const npack = this.packLastRow;
        const datebeginfact = "";
        const datebank = this.editForm.datebank;

        this.$store.commit("setRelationshipReloadAllGrids", false);
        this.$store.dispatch("linkRelationship", {
          inetpay,
          paysheetid,
          transferid,
          userid,
          npack,
          datebeginfact,
          datebank
        });
      }
    },
    paymentRefreshErrors: function(value) {
      if (value) {
        this.$store.commit("setPaymentRefreshErrors", null);

        if (
          value.type === "edit" &&
          value.statusPay === "0" &&
          this.autoDistributeCheckbox
        ) {
          const payid = value.newPayId;
          this.$store.commit("clearPaymentPostingError");
          this.$store.dispatch("paymentPostingError", { payid });
        } else {
          this.paymentErrorsLastRow = value.newPayId;
          this.getErrorPayments();
        }
      }
    }
  },
  beforeCreate() {
    if (!checkAccess(76)) {
      this.$router.push("/");
    }
  },
  async created() {
    document.title = this.$t("relationship.title");
    await this.getParams({
      account: "1",
      gfirme: "1",
      gkindpay: "1",
      gusers: "1",
      gusersrelpackpay: "1",
      codepay: "1",
      guserspackedit: "1",
      street: "1",
      gregion: "1",
      statuspay: "1",
      gservice: "1",
      gzone: "1",
      gcurrency: "1"
    });

    this.packForPaymentBtnVisibled =
      this.params.goptions.cancreatepackbyps === "yes" ? true : false;

    window.addEventListener("resize", this.onResize);
  },
  beforeMount() {
    const locale = i18n.locale;
    switch (locale) {
      case "ru":
        this.agGridlocaleText = agGridLocaleRu;
        break;
      case "ua":
        this.agGridlocaleText = agGridLocaleUa;
        break;
      case "en":
        this.agGridlocaleText = agGridLocaleEn;
        break;
      default:
        this.agGridlocaleText = agGridLocaleRu;
    }

    this.paymentsRelationGridOptions = {
      suppressCellSelection: true,
      preventDefaultOnContextMenu: true,
      localeText: this.agGridlocaleText
    };

    this.packsRelationGridOptions = {
      suppressCellSelection: true,
      preventDefaultOnContextMenu: true,
      localeText: this.agGridlocaleText
    };

    this.errorPaymentsGridOptions = {
      suppressCellSelection: true,
      preventDefaultOnContextMenu: true,
      localeText: this.agGridlocaleText,
      rowClassRules: {
        "ag-state-delivered": params => params.data.coderr === "0"
      }
    };

    let filter;
    const savedFilter = this.$localStorage.get("wb-relationship-filter");
    if (savedFilter) {
      filter = JSON.parse(savedFilter);
      if (isNaN(Number(filter.sum.sumBegin))) filter.sum.sumBegin = "0.00";
      if (isNaN(Number(filter.sum.sumEnd))) filter.sum.sumEnd = "0.00";
    } else {
      const dateBegin = this.$moment()
        .subtract(1, "months")
        .format("DD.MM.YYYY");
      const dateEnd = this.$moment()
        .add(1, "months")
        .format("DD.MM.YYYY");
      filter = {
        period: {
          enabled: true,
          dateBegin: dateBegin,
          dateEnd: dateEnd
        },
        organization: {
          enabled: false,
          code: null
        },
        payment: {
          enabled: false,
          code: null
        },
        sum: {
          enabled: false,
          sumBegin: null,
          sumEnd: null
        }
      };
      this.$localStorage.set("wb-relationship-filter", JSON.stringify(filter));
    }
    this.$store.commit("setRelationshipFilter", filter);

    let compliance;
    const savedCompliance = this.$localStorage.get(
      "wb-relationship-compliance"
    );
    if (savedCompliance) {
      compliance = JSON.parse(savedCompliance);
      if (isNaN(Number(compliance.amountDifference.summa)))
        compliance.amountDifference.summa = "0.00";
    } else {
      compliance = {
        datesDifference: {
          enabled: false,
          days: ""
        },
        organizationsMatch: {
          enabled: false
        },
        paymentMethodsMatch: {
          enabled: false
        },
        amountDifference: {
          enabled: false,
          summa: null
        }
      };
      this.$localStorage.set(
        "wb-relationship-compliance",
        JSON.stringify(compliance)
      );
    }
    this.$store.commit("setComplianceFilter", compliance);
  },
  beforeDestroy() {
    this.$store.commit("setRelationshipFilter", {
      period: {
        enabled: false,
        dateBegin: "",
        dateEnd: ""
      },
      organization: {
        enabled: false,
        code: null
      },
      payment: {
        enabled: false,
        code: null
      },
      sum: {
        enabled: false,
        sumBegin: null,
        sumEnd: null
      }
    });
    this.$store.commit("setComplianceFilter", {
      datesDifference: {
        enabled: false,
        days: ""
      },
      organizationsMatch: {
        enabled: false
      },
      paymentMethodsMatch: {
        enabled: false
      },
      amountDifference: {
        enabled: false,
        summa: null
      }
    });
    this.$store.commit("setParams", null);
    this.$store.commit("clearPaymentsRelationship");
    this.$store.commit("clearPacksRelationship");
    this.$store.commit("clearStatusModifyPacksReceipts");
    this.$store.commit("clearPaymentErrors");

    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    ...mapActions(["getParams"]),
    linkBtn() {
      if (this.currentPayRowSelected.kindpay === "98") {
        const {
          paynumber,
          datepay,
          summa,
          codefirme
        } = this.currentPayRowSelected;
        const { countpay } = this.currentPackRowSelected;
        const namefirme = nameFirme(this.params.gfirme.data, codefirme);

        this.linkConfirmModal = true;
        this.$confirm(
          `${this.$t(
            "relationship.linkConfirm.linkPayment"
          )} №${paynumber} ${this.$t(
            "relationship.linkConfirm.for"
          )} ${datepay} ${this.$t(
            "relationship.linkConfirm.from"
          )} ${namefirme} ${this.$t(
            "relationship.linkConfirm.inAmount"
          )} ${summa} ${this.$t(
            "relationship.linkConfirm.withRecPay"
          )} (${countpay} ${this.$t("relationship.linkConfirm.pcs")})?`,
          this.$t("relationship.linkConfirm.title"),
          {
            confirmButtonText: this.$t("common.buttons.confirmYes"),
            cancelButtonText: this.$t("common.buttons.confirmNo"),
            cancelButtonClass: "cancel-button",
            type: "info"
          }
        )
          .then(() => {
            this.linkConfirmModal = false;
            const inetpay = "1";
            const { paysheetid, datebank } = this.currentPayRowSelected;
            const { transferid, datebeginfact } = this.currentPackRowSelected;
            const userid = "";
            const npack = "";

            this.$store.commit("setRelationshipReloadAllGrids", false);
            this.$store.dispatch("linkRelationship", {
              inetpay,
              paysheetid,
              transferid,
              userid,
              npack,
              datebeginfact: datebeginfact || "",
              datebank
            });
          })
          .catch(() => {
            this.linkConfirmModal = false;
          });
      } else {
        this.callPosting = false;
        this.linkModal = true;
      }
    },
    linkAndPostingBtn() {
      this.callPosting = true;
      this.linkModal = true;
    },
    packForPaymentBtn() {
      this.editModal = true;
    },
    errorPaymentsBtn() {
      // отключена по причине переноса на отдельную форму
      // this.searchErrorPaymentsModal = true;
    },
    onGridSizeChanged(params) {
      // params.api.sizeColumnsToFit();
    },
    onPaymentsRelationGridReady(params) {
      this.paymentsRelationGridApi = params.api;
      this.paymentsRelationColumnApi = params.columnApi;

      this.getPaymentsRelationship();
    },
    onFirstPaymentsRelationDataRendered(event) {
      setGridView(
        "wb-relationship-grid-paymentsrelationship",
        event,
        "optimal"
      );
    },
    onPaymentsRelationRowRightClicked(event) {
      this.$store.commit(
        "setGridContextMenuKey",
        "wb-relationship-grid-paymentsrelationship"
      );
      this.$store.commit("setGridContextMenuEvent", event);
      this.$store.commit("setGridContextMenuModal", true);
    },
    onPacksRelationshipGridReady(params) {
      this.packsRelationGridApi = params.api;
      this.packsRelationColumnApi = params.columnApi;
    },
    onFirstPacksRelationDataRendered(event) {
      setGridView(this.calcStorageKey, event, "optimal");
    },
    onPacksRelationshipRowRightClicked(event) {
      this.$store.commit("setGridContextMenuKey", this.calcStorageKey);
      this.$store.commit("setGridContextMenuEvent", event);
      this.$store.commit("setGridContextMenuModal", true);
    },
    onPaymentsRelationModelUpdated(params) {
      const rowCount = params.api.getDisplayedRowCount();

      this.filterType = rowCount >= 100 ? "danger" : "primary";
      this.linkBtnDisabled = rowCount === 0 ? true : false;
      this.packForPaymentBtnDisabled = rowCount === 0 ? true : false;

      params.api.forEachNode(node =>
        node.rowIndex ? 0 : node.setSelected(true)
      );
    },
    onPaymentsRelationRowSelected(params) {
      if (params.node.selected) {
        this.currentPayRowSelected = params.node.data;
        const { kindpay, codefirme, datepay, summa } = params.node.data;

        this.packsSource =
          kindpay === "98"
            ? this.packsInternetRelationColumnDefs
            : this.packsRelationColumnDefs;

        this.calcStorageKey =
          kindpay === "98"
            ? "wb-relationship-grid-packsinternetrelation"
            : "wb-relationship-grid-packsrelation";

        this.packForPaymentBtnDisabled = kindpay === "98" ? true : false;

        if (this.packsRelationGridOptions.api) {
          this.packsRelationGridOptions.api.setRowData([]);
          this.packsRelationGridOptions.api.showLoadingOverlay();
        }
        this.$store.dispatch("getPacksRelationship", {
          kindpay,
          codefirme,
          datepay,
          summa
        });
      }
    },
    onPacksRelationModelUpdated(params) {
      const rowCount = params.api.getDisplayedRowCount();
      if (rowCount === 0) {
        this.linkBtnDisabled = true;
        this.linkAndPostingBtnVisibled = false;
      } else {
        this.linkBtnDisabled = false;
        this.linkAndPostingBtnVisibled = true;
        params.api.forEachNode(node =>
          node.rowIndex ? 0 : node.setSelected(true)
        );
      }
      params.api.sizeColumnsToFit();
    },
    onPacksRelationRowSelected(params) {
      if (params.node.selected) {
        this.currentPackRowSelected = params.node.data;

        if (this.currentPayRowSelected.kindpay === "98") {
          const arg1 = $(this.currentPayRowSelected.summa)
            .minus($(this.currentPackRowSelected.summtrans))
            .toNumber();

          const arg2 = 0.01 * parseInt(this.currentPackRowSelected.countpay);
          const eqdate =
            parseInt(
              this.$moment(
                this.currentPackRowSelected.dateclient,
                "DD.MM.YYYY"
              ).unix()
            ) <=
            parseInt(
              this.$moment(
                this.currentPayRowSelected.datebank,
                "DD.MM.YYYY"
              ).unix()
            );
          this.linkBtnDisabled = Math.abs(arg1) < arg2 && eqdate ? false : true;
        } else {
          this.linkBtnDisabled = false;
        }

        this.linkAndPostingBtnVisibled =
          this.currentPayRowSelected.kindpay !== "98" &&
          this.currentPackRowSelected.isimport === "1"
            ? true
            : false;
      }
    },
    onPaymentErrorsGridReady(params) {
      this.errorPaymentsGridApi = params.api;
      this.errorPaymentsColumnApi = params.columnApi;
    },
    onFirstPaymentErrorsDataRendered(event) {
      setGridView("wb-relationship-grid-paymenterrors", event, "full");
    },
    onPaymentErrorsRowRightClicked(event) {
      this.$store.commit(
        "setGridContextMenuKey",
        "wb-relationship-grid-paymenterrors"
      );
      this.$store.commit("setGridContextMenuEvent", event);
      this.$store.commit("setGridContextMenuModal", true);
    },
    onErrorPaymentsModelUpdated(params) {
      const rowCount = params.api.getDisplayedRowCount();
      if (rowCount === 0) {
        this.fixBtnDisabled = true;
        this.removeBtnDisabled = true;
        this.distributeBtnDisabled = true;
      } else {
        this.fixBtnDisabled = false;
        this.removeBtnDisabled = false;
        this.distributeBtnDisabled = true;

        params.api.forEachNode(node => {
          if (node.data.payid === this.paymentErrorsLastRow) {
            node.setSelected(true);
            params.api.ensureIndexVisible(node.rowIndex);
          } else {
            node.rowIndex ? 0 : node.setSelected(true);
          }
        });
      }
    },
    onErrorPaymentsRowSelected(params) {
      if (params.node.selected) {
        this.currentErrorPaymentRowSelected = params.node.data;

        this.distributeBtnDisabled =
          this.currentErrorPaymentRowSelected.coderr !== "0" ? true : false;
      }
    },
    onErrorPaymentsRowDoubleClicked() {
      this.onClickErrorPaymentChangeBtn("edit");
    },
    getPaymentsRelationship() {
      this.packsRelationGridOptions.api.setRowData([]);

      if (this.paymentsRelationGridOptions.api) {
        this.paymentsRelationGridOptions.api.setRowData([]);
        this.paymentsRelationGridOptions.api.showLoadingOverlay();
      }
      this.$store.dispatch("getPaymentsRelationship");
      this.paymentsRelationGridOptions.api.sizeColumnsToFit();
    },
    filterModalShow() {
      const dateBegin = this.relationshipFilter.period.dateBegin;
      const dateEnd = this.relationshipFilter.period.dateEnd;
      this.filterForm = {
        dateEnabled: this.relationshipFilter.period.enabled,
        dateRange: [dateBegin, dateEnd],
        organizationEnabled: this.relationshipFilter.organization.enabled,
        organizationCode: this.relationshipFilter.organization.code,
        paymentEnabled: this.relationshipFilter.payment.enabled,
        paymentCode: this.relationshipFilter.payment.code,
        sumEnabled: this.relationshipFilter.sum.enabled,
        sumBegin: $(this.relationshipFilter.sum.sumBegin).toNumber(),
        sumEnd: $(this.relationshipFilter.sum.sumEnd).toNumber()
      };
    },
    filterModalHide() {
      this.filterForm = {
        dateEnabled: null,
        dateRange: [],
        organizationEnabled: null,
        organizationCode: null,
        paymentEnabled: null,
        paymentCode: null,
        sumEnabled: null,
        sumBegin: 0,
        sumEnd: 0
      };
      this.$refs.filterForm.resetFields();
    },
    filterModalSubmit() {
      this.$refs.filterForm.validate(valid => {
        if (valid) {
          const filter = {
            period: {
              enabled: this.filterForm.dateEnabled,
              dateBegin: this.filterForm.dateRange[0],
              dateEnd: this.filterForm.dateRange[1]
            },
            organization: {
              enabled: this.filterForm.organizationEnabled,
              code: this.filterForm.organizationCode
            },
            payment: {
              enabled: this.filterForm.paymentEnabled,
              code: this.filterForm.paymentCode
            },
            sum: {
              enabled: this.filterForm.sumEnabled,
              sumBegin: this.filterForm.sumBegin
                ? $(this.filterForm.sumBegin).toFixed()
                : "0.00",
              sumEnd: this.filterForm.sumEnd
                ? $(this.filterForm.sumEnd).toFixed()
                : "0.00"
            }
          };

          this.$localStorage.set(
            "wb-relationship-filter",
            JSON.stringify(filter)
          );
          this.$store.commit("setRelationshipFilter", filter);
          this.filterModal = false;

          this.$store.commit("clearPacksRelationship");

          if (this.paymentsRelationGridOptions.api) {
            this.paymentsRelationGridOptions.api.setRowData([]);
            this.paymentsRelationGridOptions.api.showLoadingOverlay();
          }
          this.$store.dispatch("getPaymentsRelationship");
        }
      });
    },
    complianceModalShow() {
      this.complianceForm = {
        datesDifferenceEnabled: this.relationshipCompliance.datesDifference
          .enabled,
        datesDifferenceDays: this.relationshipCompliance.datesDifference.days,
        organizationsMatchEnabled: this.relationshipCompliance
          .organizationsMatch.enabled,
        paymentMethodsMatchEnabled: this.relationshipCompliance
          .paymentMethodsMatch.enabled,
        amountDifferenceEnabled: this.relationshipCompliance.amountDifference
          .enabled,
        amountDifferenceSumma: $(
          this.relationshipCompliance.amountDifference.summa
        ).toNumber()
      };
    },
    complianceModalHide() {
      this.complianceForm = {
        datesDifferenceEnabled: null,
        datesDifferenceDays: null,
        organizationsMatchEnabled: null,
        paymentMethodsMatchEnabled: null,
        amountDifferenceEnabled: null,
        amountDifferenceSumma: null
      };
    },
    complianceModalSubmit() {
      const compliance = {
        datesDifference: {
          enabled: this.complianceForm.datesDifferenceEnabled,
          days: this.complianceForm.datesDifferenceDays
        },
        organizationsMatch: {
          enabled: this.complianceForm.organizationsMatchEnabled
        },
        paymentMethodsMatch: {
          enabled: this.complianceForm.paymentMethodsMatchEnabled
        },
        amountDifference: {
          enabled: this.complianceForm.amountDifferenceEnabled,
          summa: this.complianceForm.amountDifferenceSumma
            ? $(this.complianceForm.amountDifferenceSumma).toFixed()
            : "0.00"
        }
      };

      this.$localStorage.set(
        "wb-relationship-compliance",
        JSON.stringify(compliance)
      );
      this.$store.commit("setComplianceFilter", compliance);
      this.complianceModal = false;

      const { kindpay, codefirme, datepay, summa } = this.currentPayRowSelected;

      if (this.packsRelationGridOptions.api) {
        this.packsRelationGridOptions.api.setRowData([]);
        this.packsRelationGridOptions.api.showLoadingOverlay();
      }
      this.$store.dispatch("getPacksRelationship", {
        kindpay,
        codefirme,
        datepay,
        summa
      });
    },
    linkModalShow() {
      let difference;
      let summa;

      if (this.currentPayRowSelected.status === "1") {
        difference = $(this.currentPayRowSelected.summa)
          .minus(
            $(this.currentPackRowSelected.summa).minus(
              $(this.currentPackRowSelected.sumprof)
            )
          )
          .toNumber();
        summa =
          $(this.currentPayRowSelected.summa).toNumber() !==
          $(this.currentPackRowSelected.summa)
            .minus($(this.currentPackRowSelected.sumprof))
            .toNumber();
      } else {
        difference = $(this.currentPayRowSelected.summa)
          .minus($(this.currentPackRowSelected.summa))
          .toNumber();
        summa =
          $(this.currentPayRowSelected.summa).toNumber() !==
          $(this.currentPackRowSelected.summa).toNumber();
      }

      this.linkForm = {
        payment: {
          codefirme: this.currentPayRowSelected.codefirme,
          datebank: this.currentPayRowSelected.datebank,
          datepay: this.currentPayRowSelected.datepay,
          summa: $(this.currentPayRowSelected.summa).toNumber(),
          status: this.currentPayRowSelected.status === "1" ? true : false
        },
        pack: {
          codefirme: this.currentPackRowSelected.codefirme,
          datebank: this.currentPackRowSelected.datebank,
          summa: $(this.currentPackRowSelected.summa).toNumber(),
          quantity: this.currentPackRowSelected.quantity,
          sumprof: $(this.currentPackRowSelected.sumprof).toNumber(),
          countband: this.currentPackRowSelected.countband
        },
        notEqual: {
          codefirme:
            this.currentPayRowSelected.codefirme ===
            this.currentPackRowSelected.codefirme
              ? false
              : true,
          datebank:
            this.currentPayRowSelected.datebank ===
            this.currentPackRowSelected.datebank
              ? false
              : true,
          summa: summa,
          difference: difference === 0 ? false : true
        },
        difference: difference,
        userid: this.currentPackRowSelected.userid
      };
    },
    linkModalHide() {
      this.linkForm = {
        payment: {
          codefirme: null,
          datebank: null,
          datepay: null,
          summa: 0,
          status: null
        },
        pack: {
          codefirme: null,
          datebank: null,
          summa: 0,
          quantity: null,
          sumprof: null,
          countband: null
        },
        notEqual: {
          codefirme: false,
          datebank: false,
          summa: 0,
          difference: false
        },
        difference: 0,
        userid: null
      };
      this.$refs.moreInfo.scrollTo(0, 0);
      this.$refs.linkForm.resetFields();
    },
    linkModalSubmit() {
      this.$refs.linkForm.validate(valid => {
        if (valid) {
          if (
            this.linkForm.notEqual.codefirme ||
            this.linkForm.notEqual.datebank ||
            this.linkForm.notEqual.summa
          ) {
            this.linkSubmitModal = true;
            this.$confirm(
              this.$t("relationship.linkConfirm.attention"),
              this.$t("relationship.linkConfirm.title"),
              {
                confirmButtonText: this.$t("common.buttons.confirmYes"),
                cancelButtonText: this.$t("common.buttons.confirmNo"),
                cancelButtonClass: "cancel-button",
                type: "warning"
              }
            )
              .then(() => {
                this.linkSubmitModal = false;
                this.linkPaymentPack();
              })
              .catch(() => {
                this.linkSubmitModal = false;
              });
          } else {
            this.linkPaymentPack();
          }
        }
      });
    },
    linkPaymentPack() {
      const inetpay = "0";
      const { paysheetid, datebank } = this.currentPayRowSelected;
      const { npack, datebeginfact } = this.currentPackRowSelected;
      const transferid = "";
      const userid = this.linkForm.userid;

      this.$store.commit("setRelationshipReloadAllGrids", false);
      this.$store.dispatch("linkRelationship", {
        inetpay,
        paysheetid,
        transferid,
        userid,
        npack,
        datebeginfact,
        datebank
      });
    },

    editModalShow() {
      this.visibleSumprof = true;
      this.visibleOperator = false;
      this.titleEditModal = this.$t(
        "packsreceipts.editForm.modal.title.packageInfo"
      );
      this.labelQuantity = this.$t(
        "packsreceipts.editForm.form.quantity.numberReceipts"
      );
      this.labelCountband = this.$t(
        "packsreceipts.editForm.form.countband.numberCountband"
      );

      const {
        paysheetid,
        datepay,
        codefirme,
        kindpay,
        summa,
        mess
      } = this.currentPayRowSelected;

      this.editForm.paysheetid = paysheetid;
      this.editForm.datebank = datepay;
      this.editForm.codefirme = codefirme;
      this.editForm.kindpay = kindpay;
      this.editForm.summa = $(summa).toNumber();
      this.editForm.infoPay = mess;
      this.editForm.useridCode = this.user.userid.toString();
      this.editForm.userid = this.user.userid.toString();

      this.editForm.payments = this.params.gkindpay.data.filter(
        item =>
          !["50", "90", "97", "98", "100"].includes(item.kindpay) &&
          item.used === "1"
      );

      this.infoPayBtnDisabled = this.editForm.infoPay === "" ? true : false;
    },
    editModalHide() {
      this.editForm = {
        isimport: null,
        packnumber: null,
        datebank: null,
        mfo: null,
        codefirmeCode: null,
        codefirme: null,
        senders: [],
        accountSender: null,
        kindpayCode: null,
        kindpay: null,
        payments: [],
        quantity: null,
        countband: null,
        summa: 0,
        sumprof: 0,
        paysheetid: null,
        datebeginfact: null,
        npack: null,
        useridCode: null,
        userid: null,
        infoPay: ""
      };
      this.$refs.editForm.resetFields();

      if (this.paymentNotify) this.paymentNotify.close();

      this.packLastRow = null;
    },
    confirmAdd(confirm) {
      const {
        packnumber,
        datebank,
        codefirme,
        countband,
        kindpay,
        summa,
        sumprof,
        quantity,
        isimport,
        userid
      } = this.editForm;

      const behavior = "2";
      const checkSumprof = ["88", "91", "99"].includes(kindpay) ? 0 : sumprof;

      this.$store.commit("clearStatusModifyPacksReceipts");
      this.$store.dispatch("packsReceiptsAdd", {
        behavior,
        packnumber: packnumber || "",
        datebank,
        codefirme,
        countband,
        kindpay,
        summa: summa ? $(summa).toFixed() : "0",
        sumprof: checkSumprof ? $(checkSumprof).toFixed() : "0",
        quantity,
        isimport: isimport || "",
        userid,
        confirm
      });
    },
    editModalSubmit() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          // 1-й этап создания пачки, confirm = "", возможны вопросы в ответе
          this.confirmAdd("");
        }
      });
    },
    getErrorPayments() {
      if (this.errorPaymentsGridOptions.api) {
        this.errorPaymentsGridOptions.api.setRowData([]);
        this.errorPaymentsGridOptions.api.showLoadingOverlay();
      }

      const perror = "1";
      const {
        abcode,
        abcodeTypeSearch,
        sumPayBegin,
        sumPayEnd,
        sumPayTypeSearch,
        dateBankBegin,
        dateBankEnd,
        dateBankTypeSearch,
        datePayBegin,
        datePayEnd,
        datePayTypeSearch,
        dateChangeBegin,
        dateChangeEnd,
        dateChangeTypeSearch,
        errorType,
        npack,
        datePayFrom,
        datePayTo,
        kindpay,
        codefirme,
        note,
        noteTypeSearch
      } = this.searchErrorPaymentsForm;

      this.$store.dispatch("getPaymentErrors", {
        perror,
        abcode,
        abcodeTypeSearch,
        sumPayBegin: sumPayBegin || 0,
        sumPayEnd: sumPayEnd || 0,
        sumPayTypeSearch,
        dateBankBegin: dateBankBegin || "",
        dateBankEnd: dateBankEnd || "",
        dateBankTypeSearch,
        datePayBegin: datePayBegin || "",
        datePayEnd: datePayEnd || "",
        datePayTypeSearch,
        dateChangeBegin: dateChangeBegin || "",
        dateChangeEnd: dateChangeEnd || "",
        dateChangeTypeSearch,
        errorType: errorType || "",
        npack: npack || "",
        datePayFrom: datePayFrom || "",
        datePayTo: datePayTo || "",
        kindpay: kindpay || "",
        codefirme: codefirme || "",
        note,
        noteTypeSearch
      });
    },
    errorPaymentsModalHide() {
      this.$store.commit("clearPaymentErrors");
    },
    searchErrorPaymentsModalShow() {
      this.searchErrorPaymentsForm = {
        abcode: "",
        abcodeTypeSearch: "1",
        sumPayBegin: 0,
        sumPayEnd: 0,
        sumPayTypeSearch: "0",
        dateBankBegin: "",
        dateBankEnd: "",
        dateBankTypeSearch: "0",
        datePayBegin: "",
        datePayEnd: "",
        datePayTypeSearch: "0",
        dateChangeBegin: "",
        dateChangeEnd: "",
        dateChangeTypeSearch: "0",
        errorType: null,
        npack: null,
        datePayFrom: "",
        datePayTo: "",
        kindpay: null,
        codefirme: null,
        note: "",
        noteTypeSearch: "1"
      };

      this.extendedSearch = false;
    },
    searchErrorPaymentsModalHide() {
      this.$refs.searchErrorPayments.scrollTo(0, 0);
    },
    searchErrorPaymentsFormSubmit() {
      this.$refs.searchErrorPaymentsForm.validate(valid => {
        if (valid) {
          this.getErrorPayments(); // refactoring, no spinner !!!
          this.searchErrorPaymentsModal = false;
          this.errorPaymentsModal = true;
        }
      });
    },
    onClickInfoPay() {
      if (!this.paymentNotify) {
        this.paymentNotify = this.$notify({
          title: `${this.$t("common.errors.note")}`,
          message: this.editForm.infoPay,
          duration: 0,
          position: "top-left",
          onClose: () => {
            this.paymentNotify = null;
          }
        });
      } else {
        this.paymentNotify.close();
      }
    },
    onChangeMfo(value) {
      if (value) {
        const gfirme = this.params.gfirme.data.filter(
          item => item.mfo === value
        );
        if (gfirme.length > 0 && this.editForm.datebank) {
          this.editForm.codefirme = gfirme[0].codefirme;
        }
      } else {
        this.editForm.codefirme = null;
      }
    },
    onClickErrorPaymentChangeBtn(state) {
      const { payid } = this.currentErrorPaymentRowSelected;

      const payload = {
        state,
        npack: "",
        payid,
        date: "",
        sumPay: 0,
        kindpay: "",
        countpay: 0,
        note: ""
      };
      this.$store.commit("setPaymentData", payload);
      this.$store.commit("setPaymentModal", true);
    },
    onClickErrorPaymentDistributeBtn() {
      const { payid } = this.currentErrorPaymentRowSelected;

      this.$store.commit("clearPaymentPostingError");
      this.$store.dispatch("paymentPostingError", { payid });
    },
    onChangeKindpayCode(event) {
      const value = event.target.value;
      const kindpays = this.editForm.payments.filter(
        item => item.kindpay === value
      );
      if (kindpays.length > 0) {
        this.editForm.kindpay = value;
      } else {
        this.editForm.kindpay = null;
        this.editForm.kindpayCode = null;
      }
    },
    onChangeUseridCode(event) {
      const value = event.target.value;
      const users = this.params.gusersrelpackpay.data.filter(
        item => item.userid === value
      );
      if (users.length > 0) {
        this.linkForm.userid = value;
      } else {
        this.linkForm.userid = null;
        this.linkForm.useridCode = null;
      }
    },
    onChangeUseridCodeEditForm(event) {
      const value = event.target.value;
      const users = this.params.guserspackedit.data.filter(
        item => item.userid === value
      );
      if (users.length > 0) {
        this.editForm.userid = value;
      } else {
        this.editForm.userid = null;
        this.editForm.useridCode = null;
      }
    },
    onChangeCodefirmeCode(event) {
      const value = event.target.value;
      const firms = this.params.gfirme.data.filter(
        item => item.userid === value
      );
      if (firms.length > 0) {
        this.linkForm.payment.codefirme = value;
      } else {
        this.linkForm.payment.codefirme = null;
        this.linkForm.payment.codefirmeCode = null;
      }
    },
    onChangeCodefirmeCodeEditForm(event) {
      const value = event.target.value;
      const codefirmes = this.editForm.senders.filter(
        item => item.codefirme === value
      );
      if (codefirmes.length > 0) {
        this.editForm.codefirme = value;
      } else {
        this.editForm.codefirme = null;
        this.editForm.codefirmeCode = null;
      }
    },
    onShortKeyRouter(event) {
      switch (event.srcKey) {
        case "F2":
          // errorPaymentsModal: F2 - auto distribute
          if (
            !this.filterModal &&
            !this.editModal &&
            !this.complianceModal &&
            !this.linkModal &&
            !this.linkConfirmModal &&
            !this.linkSubmitModal &&
            !this.paymentModal &&
            !this.searchErrorPaymentsModal &&
            this.errorPaymentsModal
          ) {
            this.autoDistributeCheckbox = !this.autoDistributeCheckbox;
            // searchErrorPaymentsModal: F2 - extended search
          } else if (
            !this.filterModal &&
            !this.editModal &&
            !this.complianceModal &&
            !this.linkModal &&
            !this.linkConfirmModal &&
            !this.linkSubmitModal &&
            !this.paymentModal &&
            !this.errorPaymentsModal &&
            this.searchErrorPaymentsModal
          ) {
            this.extendedSearch = !this.extendedSearch;
          }
          break;
        case "F4":
          // errorPaymentsModal
          if (
            !this.filterModal &&
            !this.editModal &&
            !this.complianceModal &&
            !this.linkModal &&
            !this.linkConfirmModal &&
            !this.linkSubmitModal &&
            !this.paymentModal &&
            this.errorPaymentsModal &&
            !this.fixBtnDisabled &&
            !this.searchErrorPaymentsModal
          ) {
            this.onClickErrorPaymentChangeBtn("edit");
          }
          break;
        case "F6":
          // link and posting
          if (this.checkAllModal) {
            this.linkAndPostingBtn();
          }
          break;
        case "F7":
          // filterModal
          if (this.checkAllModal) {
            this.filterModal = true;
          }
          break;
        case "F8":
          // pack for payment
          if (this.checkAllModal) {
            this.packForPaymentBtn();
          }
          break;
        case "F9":
          // complianceModal
          if (this.checkAllModal) {
            this.complianceModal = true;
          }
          // errorPaymentsModal
          if (
            !this.filterModal &&
            !this.editModal &&
            !this.complianceModal &&
            !this.linkModal &&
            !this.linkConfirmModal &&
            !this.linkSubmitModal &&
            !this.paymentModal &&
            this.errorPaymentsModal &&
            !this.distributeBtnDisabled &&
            !this.searchErrorPaymentsModal
          ) {
            this.onClickErrorPaymentDistributeBtn();
          }
          break;
        case "F10":
          // submit: filterModalSubmit
          if (this.filterModal) {
            this.filterModalSubmit();
          }
          // submit: complianceModalSubmit
          else if (this.complianceModal) {
            this.complianceModalSubmit();
          }
          // submit: linkModalSubmit
          else if (this.linkModal) {
            this.linkModalSubmit();
          }
          // submit: editModalSubmit
          else if (this.editModal) {
            this.editModalSubmit();
          }
          // submit: searchErrorPaymentsModal
          else if (this.searchErrorPaymentsModal) {
            this.searchErrorPaymentsFormSubmit();
          }
          break;
        case "Enter":
          // link
          if (this.checkAllModal && !this.linkBtnDisabled) {
            this.linkBtn();
          }
          // errorPaymentsModal
          else if (
            !this.filterModal &&
            !this.editModal &&
            !this.complianceModal &&
            !this.linkModal &&
            !this.linkConfirmModal &&
            !this.linkSubmitModal &&
            !this.paymentModal &&
            this.errorPaymentsModal &&
            !this.fixBtnDisabled &&
            !this.searchErrorPaymentsModal
          ) {
            this.onClickErrorPaymentChangeBtn("edit");
          }
          break;
        case "Insert":
        case "Plus":
          // link
          if (this.checkAllModal && !this.linkBtnDisabled) {
            this.linkBtn();
          }
          break;
        case "Del":
        case "Minus":
          // errorPaymentsModal
          if (
            !this.filterModal &&
            !this.editModal &&
            !this.complianceModal &&
            !this.linkModal &&
            !this.linkConfirmModal &&
            !this.linkSubmitModal &&
            !this.paymentModal &&
            this.errorPaymentsModal &&
            !this.removeBtnDisabled &&
            !this.searchErrorPaymentsModal
          ) {
            this.onClickErrorPaymentChangeBtn("del");
          }
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.buttons-header {
  display: flex;
}

.grid-container {
  margin-top: 10px;
  height: calc(50vh - 93px);
  overflow-y: auto;
}

.moneydisable {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #c0c4cc;
  cursor: not-allowed;
  &:hover {
    border-color: #e4e7ed;
  }
}

.not-eqaul-input {
  background-color: #faf4b6;
  color: #7c7d7f;
}

.not-eqaul-difference {
  background-color: #faf4b6;
  color: red;
  font-weight: bold;
}

.el-card__header {
  padding: 10px 20px;
}

.el-dialog__body {
  padding: 20px 20px;
}

.card-font-header {
  font-weight: bold;
}

.grid-error-container-modal {
  height: calc(100vh - 210px);
  overflow-y: auto;
}
</style>

<style lang="scss">
.el-select.not-eqaul-select .el-input__inner {
  background-color: #faf4b6;
  color: #7c7d7f;
}

.el-date-editor.not-eqaul-date .el-input__inner {
  background-color: #faf4b6;
  color: #7c7d7f;
}

.el-input-number .el-input__inner {
  text-align: left;
}
</style>
